var translationsTH = {
    ERROR : {
        UNKNOWN : "พบข้อผิดพลาด <br/>  กรุณาลองใหม่อีกครั้งภายหลัง",
        PRE_REGISTER : "<p><strong>กรุณาแก้ไขข้อมูล</strong></p>อาจเกิดจากการกรอกข้อมูลผิด<br>หรือ ข้อมูลไม่ถูกต้อง<br>กรุณาลองใหม่ หรือ ติดต่อ<br>โทร 1240",
        PRE_REGISTER_ACCOUNT_FREEZED : "<p><strong>คุณไม่สามารถใช้บัญชี<br>ทรูมันนี่ วอลเล็ทนี้ได้</strong></p>กรุณาติดต่อ 1240",
        KYC_VERIFY_DOPA_FAIL: "<p><strong>ข้อมูลการลงทะเบียนของคุณไม่ถูกต้อง</strong></p>กรุณากรอกข้อมูลให้ตรงตามบัตรประชาชน",
        REGISTER_FAIL : "<p><strong>ข้อมูลการลงทะเบียนของคุณไม่ถูกต้อง</strong></p>กรุณาตรวจสอบใหม่อีกครั้ง"
    },
    PRE_REGISTER : {
        THAI_ID_INFO : "กรุณากรอกข้อมูลที่ถูกต้อง<br/> เพื่อใช้อ้างอิงกับทรูมันนี่ วอลเล็ท<br/> เมื่อคุณเกิดปัญหาการใช้งาน"
    },
    THAI_ID : {
        INVALID_LEN : "กรุณากรอก เลขบัตรประชาชน 13 หลัก",
        INVALID_CHECK_SUM : "เลขบัตรประชาชนไม่ถูกต้อง"
    },
    LASER : {
      INVALID_FORMAT : "เลขหลังบัตรขึ้นต้นด้วยตัวอักษร 2 ตัว ตามด้วยเลข 10 หลัก",
      INVALID_LEN:"กรุณากรอก เลขหลังบัตรประชาชน 12 หลัก"
    },
    DOB : {
      ERROR : "กรุณาเลือกวัน เดือน ปีเกิด"
    },
    EMAIL : {
      INVALID_FORMAT : "รูปแบบอีเมลไม่ถูกต้อง",
      INVALID : "กรุณากรอกอีเมล",
      USED : "อีเมลนี้ลงทะเบียนไว้แล้ว กรุณาใช้อีเมลอื่น"
    },
    FULLNAME : {
      INVALID_TITLE : "กรุณาเลือกคำนำหน้าชื่อ",
      INVALID_TITLE_AND_FIRSTNAME : "กรุณาเลือกคำนำหน้าชื่อ และ ชื่อตามบัตรประชาชน",
      INVALID_FIRSTNAME : "กรุณากรอก ชื่อตามบัตรประชาชน",
      INVALID_LASTNAME : "กรุณากรอก นามสกุลตามบัตรประชาชน"
    },
    OTP : {
      INVALID : "รหัส OTP ไม่ถูกต้อง กรุณาลองอีกครั้ง"
    }
};

// jQuery Mask Plugin v1.14.8
// github.com/igorescobar/jQuery-Mask-Plugin
var $jscomp={scope:{},findInternal:function(a,f,c){a instanceof String&&(a=String(a));for(var l=a.length,g=0;g<l;g++){var b=a[g];if(f.call(c,b,g,a))return{i:g,v:b}}return{i:-1,v:void 0}}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(a,f,c){if(c.get||c.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[f]=c.value)};
$jscomp.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};$jscomp.global=$jscomp.getGlobal(this);$jscomp.polyfill=function(a,f,c,l){if(f){c=$jscomp.global;a=a.split(".");for(l=0;l<a.length-1;l++){var g=a[l];g in c||(c[g]={});c=c[g]}a=a[a.length-1];l=c[a];f=f(l);f!=l&&null!=f&&$jscomp.defineProperty(c,a,{configurable:!0,writable:!0,value:f})}};
$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(a,c){return $jscomp.findInternal(this,a,c).v}},"es6-impl","es3");
(function(a,f,c){"function"===typeof define&&define.amd?define(["jquery"],a):"object"===typeof exports?module.exports=a(require("jquery")):a(f||c)})(function(a){var f=function(b,h,e){var d={invalid:[],getCaret:function(){try{var a,n=0,h=b.get(0),e=document.selection,k=h.selectionStart;if(e&&-1===navigator.appVersion.indexOf("MSIE 10"))a=e.createRange(),a.moveStart("character",-d.val().length),n=a.text.length;else if(k||"0"===k)n=k;return n}catch(A){}},setCaret:function(a){try{if(b.is(":focus")){var p,
d=b.get(0);d.setSelectionRange?d.setSelectionRange(a,a):(p=d.createTextRange(),p.collapse(!0),p.moveEnd("character",a),p.moveStart("character",a),p.select())}}catch(z){}},events:function(){b.on("keydown.mask",function(a){b.data("mask-keycode",a.keyCode||a.which);b.data("mask-previus-value",b.val())}).on(a.jMaskGlobals.useInput?"input.mask":"keyup.mask",d.behaviour).on("paste.mask drop.mask",function(){setTimeout(function(){b.keydown().keyup()},100)}).on("change.mask",function(){b.data("changed",!0)}).on("blur.mask",
function(){c===d.val()||b.data("changed")||b.trigger("change");b.data("changed",!1)}).on("blur.mask",function(){c=d.val()}).on("focus.mask",function(b){!0===e.selectOnFocus&&a(b.target).select()}).on("focusout.mask",function(){e.clearIfNotMatch&&!g.test(d.val())&&d.val("")})},getRegexMask:function(){for(var a=[],b,d,e,k,c=0;c<h.length;c++)(b=m.translation[h.charAt(c)])?(d=b.pattern.toString().replace(/.{1}$|^.{1}/g,""),e=b.optional,(b=b.recursive)?(a.push(h.charAt(c)),k={digit:h.charAt(c),pattern:d}):
a.push(e||b?d+"?":d)):a.push(h.charAt(c).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"));a=a.join("");k&&(a=a.replace(new RegExp("("+k.digit+"(.*"+k.digit+")?)"),"($1)?").replace(new RegExp(k.digit,"g"),k.pattern));return new RegExp(a)},destroyEvents:function(){b.off("input keydown keyup paste drop blur focusout ".split(" ").join(".mask "))},val:function(a){var d=b.is("input")?"val":"text";if(0<arguments.length){if(b[d]()!==a)b[d](a);d=b}else d=b[d]();return d},calculateCaretPosition:function(a,d){var h=
d.length,e=b.data("mask-previus-value"),k=e.length;8===b.data("mask-keycode")&&e!==d?a-=d.slice(0,a).length-e.slice(0,a).length:e!==d&&(a=a>=k?h:a+(d.slice(0,a).length-e.slice(0,a).length));return a},behaviour:function(e){e=e||window.event;d.invalid=[];var h=b.data("mask-keycode");if(-1===a.inArray(h,m.byPassKeys)){var h=d.getMasked(),c=d.getCaret();setTimeout(function(a,b){d.setCaret(d.calculateCaretPosition(a,b))},10,c,h);d.val(h);d.setCaret(c);return d.callbacks(e)}},getMasked:function(a,b){var c=
[],p=void 0===b?d.val():b+"",k=0,g=h.length,f=0,l=p.length,n=1,v="push",w=-1,r,u;e.reverse?(v="unshift",n=-1,r=0,k=g-1,f=l-1,u=function(){return-1<k&&-1<f}):(r=g-1,u=function(){return k<g&&f<l});for(var y;u();){var x=h.charAt(k),t=p.charAt(f),q=m.translation[x];if(q)t.match(q.pattern)?(c[v](t),q.recursive&&(-1===w?w=k:k===r&&(k=w-n),r===w&&(k-=n)),k+=n):t===y?y=void 0:q.optional?(k+=n,f-=n):q.fallback?(c[v](q.fallback),k+=n,f-=n):d.invalid.push({p:f,v:t,e:q.pattern}),f+=n;else{if(!a)c[v](x);t===x?
f+=n:y=x;k+=n}}p=h.charAt(r);g!==l+1||m.translation[p]||c.push(p);return c.join("")},callbacks:function(a){var f=d.val(),p=f!==c,g=[f,a,b,e],k=function(a,b,d){"function"===typeof e[a]&&b&&e[a].apply(this,d)};k("onChange",!0===p,g);k("onKeyPress",!0===p,g);k("onComplete",f.length===h.length,g);k("onInvalid",0<d.invalid.length,[f,a,b,d.invalid,e])}};b=a(b);var m=this,c=d.val(),g;h="function"===typeof h?h(d.val(),void 0,b,e):h;m.mask=h;m.options=e;m.remove=function(){var a=d.getCaret();d.destroyEvents();
d.val(m.getCleanVal());d.setCaret(a);return b};m.getCleanVal=function(){return d.getMasked(!0)};m.getMaskedVal=function(a){return d.getMasked(!1,a)};m.init=function(c){c=c||!1;e=e||{};m.clearIfNotMatch=a.jMaskGlobals.clearIfNotMatch;m.byPassKeys=a.jMaskGlobals.byPassKeys;m.translation=a.extend({},a.jMaskGlobals.translation,e.translation);m=a.extend(!0,{},m,e);g=d.getRegexMask();if(c)d.events(),d.val(d.getMasked());else{e.placeholder&&b.attr("placeholder",e.placeholder);b.data("mask")&&b.attr("autocomplete",
"off");c=0;for(var f=!0;c<h.length;c++){var l=m.translation[h.charAt(c)];if(l&&l.recursive){f=!1;break}}f&&b.attr("maxlength",h.length);d.destroyEvents();d.events();c=d.getCaret();d.val(d.getMasked());d.setCaret(c)}};m.init(!b.is("input"))};a.maskWatchers={};var c=function(){var b=a(this),c={},e=b.attr("data-mask");b.attr("data-mask-reverse")&&(c.reverse=!0);b.attr("data-mask-clearifnotmatch")&&(c.clearIfNotMatch=!0);"true"===b.attr("data-mask-selectonfocus")&&(c.selectOnFocus=!0);if(l(b,e,c))return b.data("mask",
new f(this,e,c))},l=function(b,c,e){e=e||{};var d=a(b).data("mask"),h=JSON.stringify;b=a(b).val()||a(b).text();try{return"function"===typeof c&&(c=c(b)),"object"!==typeof d||h(d.options)!==h(e)||d.mask!==c}catch(u){}},g=function(a){var b=document.createElement("div"),c;a="on"+a;c=a in b;c||(b.setAttribute(a,"return;"),c="function"===typeof b[a]);return c};a.fn.mask=function(b,c){c=c||{};var e=this.selector,d=a.jMaskGlobals,h=d.watchInterval,d=c.watchInputs||d.watchInputs,g=function(){if(l(this,b,
c))return a(this).data("mask",new f(this,b,c))};a(this).each(g);e&&""!==e&&d&&(clearInterval(a.maskWatchers[e]),a.maskWatchers[e]=setInterval(function(){a(document).find(e).each(g)},h));return this};a.fn.masked=function(a){return this.data("mask").getMaskedVal(a)};a.fn.unmask=function(){clearInterval(a.maskWatchers[this.selector]);delete a.maskWatchers[this.selector];return this.each(function(){var b=a(this).data("mask");b&&b.remove().removeData("mask")})};a.fn.cleanVal=function(){return this.data("mask").getCleanVal()};
a.applyDataMask=function(b){b=b||a.jMaskGlobals.maskElements;(b instanceof a?b:a(b)).filter(a.jMaskGlobals.dataMaskAttr).each(c)};g={maskElements:"input,td,span,div",dataMaskAttr:"*[data-mask]",dataMask:!0,watchInterval:300,watchInputs:!0,useInput:!/Chrome\/28/.test(window.navigator.userAgent)&&g("input"),watchDataMask:!1,byPassKeys:[9,16,17,18,36,37,38,39,40,91],translation:{0:{pattern:/\d/},9:{pattern:/\d/,optional:!0},"#":{pattern:/\d/,recursive:!0},A:{pattern:/[a-zA-Z0-9]/},S:{pattern:/[a-zA-Z]/}}};
a.jMaskGlobals=a.jMaskGlobals||{};g=a.jMaskGlobals=a.extend(!0,{},g,a.jMaskGlobals);g.dataMask&&a.applyDataMask();setInterval(function(){a.jMaskGlobals.watchDataMask&&a.applyDataMask()},g.watchInterval)},window.jQuery,window.Zepto);

/*!
 * Bootstrap v3.3.4 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.4",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a(f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.4",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")&&(c.prop("checked")&&this.$element.hasClass("active")?a=!1:b.find(".active").removeClass("active")),a&&c.prop("checked",!this.$element.hasClass("active")).trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active"));a&&this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target);d.hasClass("btn")||(d=d.closest(".btn")),b.call(d,"toggle"),c.preventDefault()}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.4",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));return a>this.$items.length-1||0>a?void 0:this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){return this.sliding?void 0:this.slide("next")},c.prototype.prev=function(){return this.sliding?void 0:this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.4",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){b&&3===b.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=c(d),f={relatedTarget:this};e.hasClass("open")&&(e.trigger(b=a.Event("hide.bs.dropdown",f)),b.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger("hidden.bs.dropdown",f)))}))}function c(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.4",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=c(e),g=f.hasClass("open");if(b(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a('<div class="dropdown-backdrop"/>').insertAfter(a(this)).on("click",b);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger("shown.bs.dropdown",h)}return!1}},g.prototype.keydown=function(b){if(/(38|40|27|32)/.test(b.which)&&!/input|textarea/i.test(b.target.tagName)){var d=a(this);if(b.preventDefault(),b.stopPropagation(),!d.is(".disabled, :disabled")){var e=c(d),g=e.hasClass("open");if(!g&&27!=b.which||g&&27==b.which)return 27==b.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find('[role="menu"]'+h+', [role="listbox"]'+h);if(i.length){var j=i.index(b.target);38==b.which&&j>0&&j--,40==b.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",b).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",'[role="menu"]',g.prototype.keydown).on("keydown.bs.dropdown.data-api",'[role="listbox"]',g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.4",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in").attr("aria-hidden",!1),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").attr("aria-hidden",!0).off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a('<div class="modal-backdrop '+e+'" />').appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.init("tooltip",a,b)};c.VERSION="3.3.4",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(this.options.viewport.selector||this.options.viewport),this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c&&c.$tip&&c.$tip.is(":visible")?void(c.hoverState="in"):(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.options.container?a(this.options.container):this.$element.parent(),p=this.getPosition(o);h="bottom"==h&&k.bottom+m>p.bottom?"top":"top"==h&&k.top-m<p.top?"bottom":"right"==h&&k.right+l>p.width?"left":"left"==h&&k.left-l<p.left?"right":h,f.removeClass(n).addClass(h)}var q=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(q,h);var r=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",r).emulateTransitionEnd(c.TRANSITION_DURATION):r()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top=b.top+g,b.left=b.left+h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);return this.$element.trigger(g),g.isDefaultPrevented()?void 0:(f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this)},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=d?{top:0,left:0}:b.offset(),g={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},h=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,g,h,f)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.width&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){return this.$tip=this.$tip||a(this.options.template)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type)})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;(e||!/destroy|hide/.test(b))&&(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.4",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.4",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.4",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){
var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.4",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return c>e?"top":!1;if("bottom"==this.affixed)return null!=c?e+this.unpin<=f.top?!1:"bottom":a-d>=e+g?!1:"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&c>=e?"top":null!=d&&i+j>=a-d?"bottom":!1},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=a(document.body).height();"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'angular-jwt', 'pascalprecht.translate']);

})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('thaiId', function ($rootScope, modalFactory, $filter, $timeout) {
      return {
        restrict: 'E',
        require: '^form',
        scope: {
          thaiid: '=thaiid',
          info: '=?info',
          label: '@label'
        },
        templateUrl: 'app/components/directives/thaiId/thaiId.html',
        link: function (scope, el, attrs, formCtrl) {
          scope.verifyThaiId = verifyThaiId;
          scope.showThaiIdInfo = showThaiIdInfo;
          scope.checkShowRegister = false;
          scope.showThaiIdError = false;
          scope.thaiIdNoMask = "";

          //init thaiid and validate format
          if ( angular.isDefined(scope.thaiid) && scope.thaiid.length == 13) {
            scope.thaiIdNoMask = scope.thaiid;
            var thaiIdMask = $filter('thaiId')(scope.thaiIdNoMask);
            $filter('thaiId')(scope.thaiIdNoMask);
            thaiIdEvent(thaiIdMask, thaiIdMask);
          }

          scope.$watch('thaiid', thaiIdEvent);

          formCtrl["thai-id"].$setValidity("hash", !false);

          function verifyThaiId(eventType) {

            var i = 0;
            var sum = 0;
            var num = '' + scope.thaiIdNoMask;
            if (eventType == 'blur') {

              if (scope.thaiIdNoMask && scope.thaiIdNoMask.length != 13) {
                scope.showThaiIdError = true;
                formCtrl["thai-id"].$setValidity("hash", !true);
                scope.checkShowRegister = false;
                return false;
              } else {
                scope.showThaiIdError = false;

                i = 0;
                sum = 0;
                num = '' + scope.thaiIdNoMask;
                for (i, sum; i < 12; i++)
                  sum += parseFloat(num.charAt(i)) * (13 - i);
                if ((11 - sum % 11) % 10 != parseFloat(num.charAt(12))) {
                  scope.showThaiIdError = true;
                  formCtrl["thai-id"].$setValidity("hash", !true);
                  scope.checkShowRegister = false;
                  return false;
                } else {
                  scope.showThaiIdError = false;
                  formCtrl["thai-id"].$setValidity("hash", !false);
                  scope.checkShowRegister = true;
                  return true;
                }
              }
            } else {
              if (scope.thaiIdNoMask && scope.thaiIdNoMask.length == 13) {
                i = 0;
                sum = 0;
                num = '' + scope.thaiIdNoMask;
                for (i, sum; i < 12; i++) {
                  sum += parseFloat(num.charAt(i)) * (13 - i);
                }

                if ((11 - sum % 11) % 10 != parseFloat(num.charAt(12))) {
                  scope.showThaiIdError = true;
                  formCtrl["thai-id"].$setValidity("hash", !true);
                  scope.checkShowRegister = false;
                  return false;
                } else {
                  scope.showThaiIdError = false;
                  formCtrl["thai-id"].$setValidity("hash", !false);
                  scope.checkShowRegister = true;
                  return true;
                }
              } else {
                scope.showThaiIdError = false;
                formCtrl["thai-id"].$setValidity("hash", !false);
                scope.checkShowRegister = false;
                return false;
              }
            }

          }

          function showThaiIdInfo() {
            modalFactory({
              type: "info",
              body: "PRE_REGISTER.THAI_ID_INFO"
            });
          }

          function thaiIdEvent(newThaiId, oldThaiId) {
            if (angular.isUndefined(newThaiId)) {
              newThaiId = "";
            }

            //allow 0-0, -
            newThaiId = newThaiId.replace(/[^0-9-]/g, "");

            //allow "-" only 2,7,13,16 position
            var re = /-/g;
            var match = re.exec(newThaiId);
            while (match) {
              if (!(match.index == 1 || match.index == 6 || match.index == 12 || match.index == 15)) {
                if (match.index == 2 || match.index == 7 || match.index == 13 || match.index == 16) {
                  newThaiId = newThaiId.substring(0, match.index - 1);
                } else {
                  newThaiId = newThaiId.substring(0, match.index);
                }
              }
              match = re.exec(newThaiId);
            }

            //thaiIdNoMask is only number
            scope.thaiIdNoMask = newThaiId.replace(/[^0-9]/g, "");

            //for set to scope
            var formatted = newThaiId;

            //add "-" at 2 position
            var isNeedDelay = false;
            if (scope.thaiIdNoMask.length == 1 && !(oldThaiId.length == 2 && newThaiId.length == 1) || (newThaiId.length == 2 && oldThaiId.length == 1)) {
              if (oldThaiId.length == 2 && newThaiId.length == 2) {
                formatted = scope.thaiIdNoMask.substring(0, 1);
                formatted += "-";
                formatted += oldThaiId.substring(1, 2);
              } else {
                formatted = scope.thaiIdNoMask.substring(0, 1);
                formatted += "-";
              }
              isNeedDelay = true;
              $timeout(
                  function () {
                    //set to scope
                    scope.thaiid = formatted;
                  }
                );
            }

            //add "-" at 6 position
            if (scope.thaiIdNoMask.length == 5 && !(oldThaiId.length == 7 && newThaiId.length == 6)
              || (newThaiId.length == 7 && oldThaiId.length == 6)
              || (newThaiId.length == 7 && oldThaiId.length == 7)
            ) {
              if (oldThaiId.length == 7 && newThaiId.length == 7) {
                formatted = scope.thaiIdNoMask.substring(0, 1);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(1, 5);
                formatted += "-" + oldThaiId.substring(6, 7);
              } else {
                formatted = scope.thaiIdNoMask.substring(0, 1)
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(1, 5);
                formatted += "-";
              }
              isNeedDelay = true;
              $timeout(
                  function () {
                    //set to scope
                    scope.thaiid = formatted;
                  }
              );
            }

            //add "-" at 12 position
            if (scope.thaiIdNoMask.length == 10 && !(oldThaiId.length == 13 && newThaiId.length == 12)
              || (newThaiId.length == 13 && oldThaiId.length == 12)
              || (newThaiId.length == 13 && oldThaiId.length == 13)
            ) {
              if (oldThaiId.length == 13 && newThaiId.length == 13) {
                formatted = scope.thaiIdNoMask.substring(0, 1);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(1, 5);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(5, 10);
                formatted += "-";
                formatted += oldThaiId.substring(12, 13);
              } else {
                formatted = scope.thaiIdNoMask.substring(0, 1)
                formatted += "-"
                formatted += scope.thaiIdNoMask.substring(1, 5);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(5, 10);
                formatted += "-";
              }
              isNeedDelay = true;
              $timeout(
                  function () {
                    //set to scope
                    scope.thaiid = formatted;
                  }
              );
            }

            //add "-" at 15 position
            if (scope.thaiIdNoMask.length == 12 && !(oldThaiId.length == 16 && newThaiId.length == 15)
              || (newThaiId.length == 16 && oldThaiId.length == 15)
              || (newThaiId.length == 16 && oldThaiId.length == 16)
            ) {
              if (oldThaiId.length == 16 && newThaiId.length == 16) {
                formatted = scope.thaiIdNoMask.substring(0, 1);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(1, 5);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(5, 10);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(10, 12);
                formatted += "-";
                formatted += oldThaiId.substring(15, 16);
              } else {
                formatted = scope.thaiIdNoMask.substring(0, 1)
                formatted += "-"
                formatted += scope.thaiIdNoMask.substring(1, 5);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(5, 10);
                formatted += "-";
                formatted += scope.thaiIdNoMask.substring(10, 12);
                formatted += "-";
              }
              isNeedDelay = true;
              $timeout(
                  function () {
                    //set to scope
                    scope.thaiid = formatted;
                  }
              );
            }

             if(!isNeedDelay){
                scope.thaiid = formatted;
             }
            

            // check if was finished thaiid will show error msg (invalid) or show success
            if (scope.thaiIdNoMask.length == 13) {
              verifyThaiId('blur');
            }

            // check if was deleted empty thaiid will show error msg (invalid 13 digit)
            if (angular.isUndefined(oldThaiId) && newThaiId === '') {
              verifyThaiId('blur');
            }
          }

        }
      }
    });


})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('laserValid', function ($timeout,modalFactory) {
      return {
        restrict: 'E',
        require: '^form',
        scope: {

          laser: '=laser',
          modalFactory: '@'
        },
        templateUrl: 'app/components/directives/laser/laser.html',
        link: function (scope, element, attrs, formCtrl) {
          scope.verifyLaser = verifyLaser;
          scope.showBackId = showBackId;
          scope.form = formCtrl;
          scope.laserNoMask = "";
          scope.eventKey = "";

          var regx = new RegExp("[A-Za-z]{2}[0-9]{10}");

          function showBackId() {
            modalFactory({
              type: "backid"
            });
          }
          element.bind("keydown keypress", function (event) {
            scope.eventKey = event.which;
        });

          scope.$watch('laser', laserEvent);

          formCtrl.laser.$setValidity("maxlength", true);

          function verifyLaser(eventType) {
            if (eventType == 'blur') {
              if (scope.laserNoMask.length < 12) {
                scope.showLaserError = true;
                formCtrl.laser.$setValidity("maxlength", false);
                scope.laserVerify = false;
              } else{
                scope.showLaserError = !regx.test(scope.laserNoMask);
                formCtrl.laser.$setValidity("maxlength", true);
                scope.laserVerify = true;
              }
            }
          }

          function laserEvent(newValue, oldValue) {
            if (angular.isUndefined(newValue)) {
              //fixed bug on Note 4 when input 14 digit
              if (scope.laserNoMask && oldValue.length == 14 && scope.eventKey != 8) {
                newValue = oldValue;
              } else {
                newValue = "";
              }
            }

            // allow only A-Z, a-z, 0-9, -
            newValue = newValue.replace(/[^A-Za-z0-9-]/g, "");

            //allow "-" only 2,7,13,16 position
            var re = /-/g;
            var match = re.exec(newValue);
            while (match) {
              if (!(match.index == 3 || match.index == 11)) {
                if (match.index == 4 || match.index == 12) {
                  newValue = newValue.substring(0, match.index - 1);
                } else {
                  newValue = newValue.substring(0, match.index);
                }
              }
              match = re.exec(newValue);
            }

            scope.laserNoMask = newValue.replace(/[^A-Za-z0-9]/g, "");
            var formatted = newValue;

            //add "-" at 4
            var isNeedDelay = false;
            if (scope.laserNoMask.length == 3 && !(oldValue.length == 4 && newValue.length == 3) || (newValue.length == 4 && oldValue.length == 3)) {

              if (oldValue.length == 4 && newValue.length == 4) {
                formatted = scope.laserNoMask.substring(0, 3);
                formatted += "-";
                formatted += oldValue.substring(3, 4);
              } else {
                formatted = scope.laserNoMask.substring(0, 3);
                formatted += "-";
              }
              isNeedDelay = true;
              $timeout(
                  function () {
                    //set to scope
                    scope.laser = formatted;
                  }
                );
            }

            //add "-" at 12 position
            if (scope.laserNoMask.length == 10 && !(oldValue.length == 12 && newValue.length == 11)
              || (newValue.length == 12 && oldValue.length == 11)
              || (newValue.length == 12 && oldValue.length == 12)) {

              if (oldValue.length == 12 && newValue.length == 12) {
                formatted = scope.laserNoMask.substring(0, 3);
                formatted += "-";
                formatted += scope.laserNoMask.substring(3, 10);
                formatted += "-" + oldValue.substring(11, 12);
              }
              else {
                formatted = scope.laserNoMask.substring(0, 3);
                formatted += "-";
                formatted += scope.laserNoMask.substring(3, 10);
                formatted += "-";
              }
              isNeedDelay = true;
              $timeout(
                  function () {
                    //set to scope
                    scope.laser = formatted;
                  }
                );
            }
            if(!isNeedDelay){
              scope.laser = formatted;
            }

            // check if was finished laser will show error msg (invalid) or show success
            if (scope.laserNoMask.length == 12) {
              verifyLaser('blur');
            }


          }
        }
      }
    });


})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('fullname', function (){
      return {
        restrict: 'E',
        require:  '^form',
        scope: {
          firstname: '=firstname',
          lastname:  '=lastname',
          title: '=title'
        },
        templateUrl: 'app/components/directives/fullname/fullname.html',
        link: function(scope, el, attrs, formCtrl) {
          scope.form = formCtrl;
          var THAI = "ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝูฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ ";

          var validFirstName = stringIsThai(scope.firstname);
          var validLastName = stringIsThai(scope.lastname);

          if (scope.firstname && validFirstName == false){
            scope.firstname = "";
            scope.lastname = "";
          }else if (scope.lastname && validLastName == false) {
            scope.firstname = "";
            scope.lastname = "";
          }else if(scope.firstname == "" || scope.lastname == ""){
            scope.firstname = "";
            scope.lastname = "";
          }

          function stringIsThai(name) {
            if (name) {
              for (var index = name.length - 1; index >= 0; --index) {
                if (THAI.indexOf(name.substring(index, index + 1)) < 0) {
                  return false;
                }
              }
              return true;
            }
          }

        }
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('email', function (){
      return {
        restrict: 'E',
        require:  '^form',
        scope: {
          email: '=email',
          invalid: '=invalid'
        },
        templateUrl: 'app/components/directives/email/email.html',
        link: function(scope, el, attrs, formCtrl) {
          scope.form = formCtrl;
        }
      }
    });


})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('dob', dob);

    function dob($filter){
      return {
        restrict: 'E',
        require:  '^form',
        scope: {
          date: '=date'
        },
        templateUrl: 'app/components/directives/dob/dob.html',

        link: function(scope, el, attrs, formCtrl) {

          scope.form = formCtrl;

          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth()+1; //January is 0!
          var yyyy = today.getFullYear();
          var yyyy100 = today.getFullYear()-100;

          if(dd<10){
            dd='0'+dd
          }

          if(mm<10){
            mm='0'+mm
          }

          if(angular.isDefined(scope.date) && scope.date != ''){
            scope.d = stringToDateObj(scope.date);
          }

          scope.today = yyyy+'-'+mm+'-'+dd;
          scope.year100 = yyyy100+'-'+mm+'-'+dd;

          scope.userLang = navigator.language || navigator.userLanguage;
          scope.navigator = navigator;

          scope.$watch('d', function () {
            if(angular.isDefined(scope.d) && scope.d != ''){
              scope.date = stringDateThToDateEn($filter('date')(scope.d, "yyyy-MM-dd"));
            }
          });

          scope.change = function () {
            scope.d = stringToDateObj(angular.element(el).find("input").val());
          };

          function stringToDateObj(dateString){
            var dt1   = parseInt(dateString.substring(8,10));
            var mon1  = parseInt(dateString.substring(5,7));
            var yr1   = parseInt(dateString.substring(0,4));

            //find bug version
            scope.myRegexpSpecific = /Chrome\/30\.0\.0\.0 Mobile/g;
            scope.myRegexpLower = /Chrome\/[0-2][0-9]\.\d+\.\d+\.\d+ Mobile/g;
            scope.vivo = /vivo Xshot Build\/KVT49L/g;

            // Chrome Mobile version 30.0.0.0 and lower
            if((scope.userLang == 'th-TH')
              && ( (scope.navigator.userAgent.search(scope.myRegexpSpecific ) != -1)
              || (scope.navigator.userAgent.search(scope.myRegexpLower) != -1) )
              && (scope.navigator.userAgent.search(scope.vivo) == -1)//match regex
            ) yr1 -= 543;

            return new Date(yr1, mon1-1, dt1);
          }

          function stringDateThToDateEn(dateString) {
            var dt = dateString.substring(8, 10);
            var mon = dateString.substring(5, 7);
            var yr = parseInt(dateString.substring(0, 4));
            return yr + "-" + mon + "-" + dt;
          }

        }
      }
    }

})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('carouselItem', carouselItem);

    function carouselItem(){
      return {
        restrict: 'E',
        transclude: false
      }
    }

})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('carousel', carousel);

    function carousel($location,$rootScope){
      return {
        restrict: 'E',
        scope: {
          items: '=items'
        },
        templateUrl: 'app/components/directives/carousel/carousel.html',
        link: function(scope,element) {

          angular.element('#myCarousel').carousel({
            "wrap":false
          }).carousel('pause');
          scope.eventState = {"state":"untouched","diffX":0,"diffY":0,"originX":0,"originY":0};

          element.bind('touchstart', function (e) {
            scope.eventState.state = "touched";
            scope.eventState.originX = e.originalEvent.touches[0].pageX;
            scope.eventState.originY = e.originalEvent.touches[0].pageY;
          });

          element.bind('touchmove', function (e) {
            scope.eventState.diffX = scope.eventState.originX - e.originalEvent.touches[0].pageX;
            scope.eventState.diffY = scope.eventState.originY - e.originalEvent.touches[0].pageY;

            if(( scope.eventState.diffX > 5 ) && scope.eventState.state == "touched" && ( scope.eventState.diffY < 150 && scope.eventState.diffY > -150 )){
              scope.swipe('next');
              scope.eventState = {"state":"untouched","diffX":0,"diffY":0,"originX":0,"originY":0};
            }
            if(( scope.eventState.diffX < 5 ) && scope.eventState.state == "touched" && ( scope.eventState.diffY < 150 && scope.eventState.diffY > -150 )){
              scope.swipe('prev');
              scope.eventState = {"state":"untouched","diffX":0,"diffY":0,"originX":0,"originY":0};
            }
          });

          element.bind('touchend', function () {
            scope.eventState = {"state":"untouched","diffX":0,"diffY":0,"originX":0,"originY":0};
          });

          scope.swipe = function(direction) {
            var currentIndex = angular.element(element).find('.carousel-indicators li.active').attr("data-slide-to");
            if(direction == "next" && currentIndex == scope.items.image.length-1){
              $location.path('/login');
              $rootScope.$apply();
            }
            angular.element(element).carousel(direction);

          };
        }
      }
    }

})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .factory('webState', getWebState);

  function getWebState($cookies, jwtHelper) {

    return function () {
      var userInfoCokie = $cookies.get("user_info");
      if (angular.isUndefined(userInfoCokie)) {
        return "";
      }
      var userData = jwtHelper.decodeToken(userInfoCokie);
      if (angular.isDefined(userData.step)) {
        return userData.step;
      }
      return "";
    }
  }
})();

(function() {
  'use strict';

  angular
      .module('acmAuthorizationWeb')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'https://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'https://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'https://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'https://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'https://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'https://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .factory('userInfo', getUserInfo);

  function getUserInfo($cookies, jwtHelper) {

    return function() {

      var userInfoCokie = $cookies.get("user_info");
      if(angular.isUndefined(userInfoCokie)){
        return {};
      }
      var userData = jwtHelper.decodeToken(userInfoCokie);

      // check biz_data
      if(angular.isUndefined(userData.biz_data)){
        userData.biz_data= { }
      }

      // check display_name
      if(angular.isUndefined(userData.biz_data.display_name)){
          userData.biz_data.display_name = "";
      }else if(userData.biz_data.display_name){
        var display_name = userData.biz_data.display_name;
        userData.biz_data.display_name = display_name.trim();
      }

      //check first_name
      if(angular.isUndefined(userData.biz_data.first_name)){
        if(!userData.biz_data.first_name){
            userData.biz_data.first_name = userData.biz_data.display_name.split(' ')[0];
            userData.biz_data.first_name = userData.biz_data.first_name.trim();
        }
      }

      //check last name
      if(angular.isUndefined(userData.biz_data.last_name)){
        if(!userData.biz_data.last_name){
            if(userData.biz_data.display_name.indexOf(" ") != -1){
              userData.biz_data.last_name = userData.biz_data.display_name.substring(userData.biz_data.display_name.indexOf(" ")+1);
            }else{
              userData.biz_data.last_name = "";
            }
            userData.biz_data.last_name = userData.biz_data.last_name.trim();
        }
      }

      //check date_of_birth
      if(angular.isUndefined(userData.biz_data.date_of_birth)){
          userData.biz_data.date_of_birth = "";
      }
      // check title
      if(angular.isUndefined(userData.biz_data.title)){
          userData.biz_data.title = "";
      }

      // check thai_id
      if(angular.isUndefined(userData.biz_data.thai_id)){
          userData.biz_data.thai_id = "";
      }
      // check email
      if(angular.isUndefined(userData.biz_data.email)){
        userData.biz_data.email = "";
      }
      return userData;
    }


}

})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .factory('userAgent', getUserAgent);

  function getUserAgent() {
    return function() {
      var ua = navigator.userAgent;
      if(/android/i.test(ua)){
        return 'android';
      }else if(/iphone/i.test(ua)){
        return 'iphone';
      }else{
        return 'web';
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('acmAuthorizationWeb')
        .factory('modalFactory', modalFactory);

    function modalFactory($log, $uibModal, $rootScope) {

        return function (config) {
            var scope = $rootScope;
            scope.fade = false;
            scope.modalType= config.type;
            scope.termcond = config.message;
            scope.allow = config.allow;
            var animationsEnabled = angular.isDefined(config.animationsEnabled) ? config.animationsEnabled : true;

            switch (scope.modalType) {
                case "info":
                    info();
                    break;
                case "notic":
                    notic();
                    break;
                case "register-condition":
                    registerCondition();
                    break;
                case "register-privacy":
                    registerPrivacy();
                    break;
                case "consent-termandcon":
                    consentAppTermandcon();
                    break;
                case "backid":
                    backid();
                    break;
                case "cancelConsent":
                    cancelConsent();
                    break;
                default:
                    info();
            }

            function info() {

                scope.modalInfo = config.body;

                var modalInstance = $uibModal.open({
                    windowClass: 'modal-info',
                    animation: animationsEnabled,
                    templateUrl: 'app/components/modal/info.html'
                });
                scope.closeInfoModal = function () {
                    modalInstance.close();
                }
            }

            function notic() {

                scope.modalBody = config.body;
                scope.fade = true;

                var modalInstance = $uibModal.open({
                    windowClass: 'modal-notic',
                    animation: animationsEnabled,
                    templateUrl: 'app/components/modal/notic.html'
                });
                scope.closeNoticModal = function () {
                    modalInstance.close();
                }
            }

            function registerCondition() {
                var modalInstance = $uibModal.open({
                    windowClass: 'termcond-modal',
                    animation: animationsEnabled,
                    templateUrl: 'app/components/modal/register-condition.html'
                });
                scope.closeRegisterConditionModal = function () {
                    modalInstance.close();
                }
            }

            function registerPrivacy() {
                var modalInstance = $uibModal.open({
                    windowClass: 'termcond-modal',
                    animation: animationsEnabled,
                    templateUrl: 'app/components/modal/register-privacy.html'
                });
                scope.closeRegisterPrivacyModal = function () {
                    modalInstance.close();
                }
            }

            function consentAppTermandcon() {
                var modalInstance = $uibModal.open({
                    windowClass: 'termcond-modal',
                    animation: animationsEnabled,
                    templateUrl: 'app/components/modal/consent-app-term-and-cond.html'
                });
                scope.closeConsentTermAndCondModal = function () {
                    modalInstance.close();
                }
            }

            function backid(){
              var modalInstance = $uibModal.open({
                  windowClass: 'termcond-modal',
                  animation: animationsEnabled,
                  templateUrl: 'app/components/modal/backid.html'
              });
              scope.closeBackidModal = function () {
                  modalInstance.close();
              }
            }

            function cancelConsent() {
                var modalInstance = $uibModal.open({
                  windowClass: 'modal-info',
                  animation: animationsEnabled,
                  templateUrl: 'app/components/modal/consent-cancel.html'
                });
                scope.closeCancelConsent = function () {
                    modalInstance.close();
                };
            }
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .factory('mixpanelFactory', mixpanelFactory);

  function mixpanelFactory($filter) {
    return function (e, userInfoObj) {
      var indentifyHash = getIdentify(userInfoObj.biz_data.mobile_no, userInfoObj.biz_data.email);
      // set identify to mixpanel lib
      mixpanel.identify(indentifyHash);

      var partnerName = "7app";
      switch (e) {
        case "sign_up":
          signup();
          break;
        case "log_in":
          login();
          break;
        case "link":
          link();
          break;
        default:
          break;
      }
      return { identify : indentifyHash , 'event' : e};

      function thaiDateTime() {
        var date = new Date();
        var localTime = date.getTime();
        var localOffset = date.getTimezoneOffset() * 60000;
        var utcPlusTimezone = localTime + localOffset;
        var dateString = $filter('date')(utcPlusTimezone, 'yyyy-MM-ddTHH:mm:ss');
        return dateString;
      }

      function getIdentify(mobile, email) {
        if(angular.isUndefined(email)) {
          email = "";
        }
        return sha1(mobile + '+' + email.substring(0, email.indexOf('@')));

      }
      function send(peopleData, eventName, eventData) {

        if (peopleData) {
          mixpanel.people.set(peopleData);
        }
        if (eventName) {
          mixpanel.track(
            eventName, eventData
          );
        }
      }
      function signup() {
        var eventName = "Sign up";
        var peopleData = {
          "Signup date": thaiDateTime(),
          "Signup channel": partnerName
        };
        send(peopleData, eventName, {});
      }

      function login() {
        var eventName = "Log in to link";
        var eventData = {
          "Partner name": partnerName,
          "Balance": userInfoObj.biz_data.balance
        };
        var peopleData = {
          "$phone": userInfoObj.biz_data.mobile_no,
          "$email": userInfoObj.biz_data.email,
          "Balance": userInfoObj.biz_data.balance,
          "Last login": thaiDateTime()
        };
        send(peopleData, eventName, eventData);
      }

      function link() {
        var eventName = "Link account";
        var eventData = {
          "Partner name": partnerName
        };
        var peopleData = {
          "Last link to 7app": thaiDateTime()
        };
        send(peopleData, eventName, eventData);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .filter('thaiId', thaiId);

  function thaiId() {
    return function (thaiIdNumber) {
      if (!thaiIdNumber) {
        return '';
      }

      var thaiIdNumberString = String(thaiIdNumber);

      var formatted = thaiIdNumberString.substring(0, 1) + "-"
        + thaiIdNumberString.substring(1, 5) + "-"
        + thaiIdNumberString.substring(5, 10) + "-"
        + thaiIdNumberString.substring(10, 12) + "-"
        + thaiIdNumberString.substring(12, 13);

      return formatted;
    };
  }

})();



(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .filter('tel', tel);

  function tel() {
      /*
       Format phonenumber as: c (xxx) xxx-xxxx
       or as close as possible if phonenumber length is not 10
       if c is not '1' (country code not USA), does not use country code
       */

      return function (number) {
        /*
         @param {Number | String} number - Number that will be formatted as telephone number
         Returns formatted number:  ###  ### ####
         if number.length < 4: ###
         else if number.length < 7: (###) ###

         Does not handle country codes that are not '1' (USA)
         */
        if (!number) { return ''; }

        number = String(number);

        // Will return formattedNumber.
        // If phonenumber isn't longer than an area code, just show number
        var formattedNumber = number;
        
        var c = '';
        // if the first character is '1', strip it out and add it back
        // c = (number[0] == '1') ? '1 ' : '';
        // number = number[0] == '1' ? number.slice(1) : number;

        // # (###) ###-#### as c (area) front-end
        var area = number.substring(0,3);
        var front = number.substring(3, 6);
        var end = number.substring(6, 10);

        if (front) {
          formattedNumber = (c + area + "-" + front);
        }
        if (end) {
          formattedNumber += ("-" + end);
        }
        return formattedNumber;
      };
    }


})();



(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .filter('laser', laser);

  function laser() {
    return function (laser) {
      if (!laser) {
        return '';
      }

      var laserString = String(laser);
      var formatted = laserString.substring(0, 3) + "-"
        + laserString.substring(3, 10) + "-"
        + laserString.substring(10, 12);

      return formatted;
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .factory('errorHandler', errorHandler);

  function errorHandler($rootScope, $location, modalFactory) {

    return function (res) {
      $rootScope.isLoading = false;
      if (res && res.data) {
        return $location.path('/error/' + res.data);
      } else {
        modalFactory({
          type: "notic",
          body: "ERROR.UNKNOWN"
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .directive('loading', function($rootScope) {


      function link(scope, element) {

        var rootScope = $rootScope;
        rootScope.isLoading = false;

        element.on('$destroy', function() {
          rootScope.isLoading = false;
        });

       
      }

      return {
        link: link
      };
    });

})();
(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .factory('clientInfo', getClientInfo);

  function getClientInfo(userInfo) {

    var responseData = {};

    return function () {
      var clientId = userInfo().client_id;
      if(Object.keys(responseData).length === 0 && angular.isDefined(clientId)){
        jQuery.ajax({
          type: "GET",
          url: apiUrl.host + apiUrl.endpoint.clientInfo.replace("{CLIENT_ID}", clientId),
          async: false
        }).done(function (data) {
          responseData = data;
        });
      }
      return responseData;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .service('registerService', RegisterService);



  function RegisterService($http) {

    var config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    this.checkProfileByEmail = checkProfileByEmail;
    function checkProfileByEmail(email) {
      return $http.get(apiUrl.host + apiUrl.endpoint.checkProfileByEmail + email, config);
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController($log, $rootScope, $scope, userInfo, $location, webState, modalFactory, registerService, dopaService, errorHandler) {
    var rootScope = $rootScope;
    var vm = $scope;

    //Check state
    if (['NEW_USER', 'NEW_USER_VERIFIED_DOPA_STEP'].indexOf(webState()) === -1) {
      return $location.path('/login');
    }

    vm.userInfo = userInfo();
    vm.email = $location.search().email ? $location.search().email : "";
    vm.submitRegister = submitRegister;
    vm.invalidEmail = false;
    vm.lastInvalidEmail = "";

    vm.init = init;
    init();

    function init() {
      //register error
      if ($location.search().errorCode == appID + '4005') {
        modalFactory({
          type: "notic",
          body: "ERROR.PRE_REGISTER_ACCOUNT_FREEZED"
        });
      }
    }

    //check email input
    vm.$watch('email', function () {
      if ($location.search().email != vm.email) {
        vm.invalidEmail = false;
      }
      if( vm.lastInvalidEmail && vm.lastInvalidEmail == vm.email){
        vm.invalidEmail = true;
      }
    });

    function submitRegister() {
      rootScope.isLoading = true;
      registerService.checkProfileByEmail(vm.email)
      .success(function (data){
        // code 1
        if(data.data.status_code == '1'){
          vm.verifyDopa();
        }else{
          vm.lastInvalidEmail = vm.email;
          showEmailError();
        }
      })
        .error(function (response) {
          errorHandler(response);
        });
    }

    vm.verifyDopa = function() {

      var dopaData = {
        thaiId: vm.userInfo.biz_data.thai_id.replace(/-/g, ''),
        title: vm.userInfo.biz_data.title,
        firstname_th: vm.userInfo.biz_data.first_name,
        lastname_th: vm.userInfo.biz_data.last_name,
        laser: vm.userInfo.biz_data.laser.replace(/-/g, ''),
        birthdate: vm.userInfo.biz_data.date_of_birth
      };

      dopaService.verifyDopa(dopaData)
        .success(
          function(data){
            rootScope.isLoading = false;
            if(data.data.status_code == '0'){
              goToOtpRegister();
            }else{
              modalFactory({
              type: "notic",
              body: "ERROR.KYC_VERIFY_DOPA_FAIL"
            });
            }
          })
        .error(
        function (response) {
          errorHandler(response);
        });
    };

    function goToOtpRegister(){
      $location.path('otp/register').search({ 'email': vm.email});
    }

    function showEmailError(){
      rootScope.isLoading = false;
      vm.invalidEmail = true;

      modalFactory({
          type: "notic",
          body: "ERROR.REGISTER_FAIL"
        });
    }

  }
})();


(function () {
    'use strict';

    angular
        .module('acmAuthorizationWeb')
        .controller('PreregisterController', PreregisterController);

    /** @ngInject */
    function PreregisterController($rootScope, $scope, $http, $location, $log, userInfo, modalFactory, errorHandler,clientInfo) {

        var scope = $scope;
        var rootScope = $rootScope;
        var clientInfoData = clientInfo();
        scope.userInfo = userInfo();
        
        scope.mobileNo = "";
        scope.isShowRegister = false;

        scope.topBaner = clientInfoData.banner;
        scope.policyTxt = clientInfoData.policy_txt;
     
        scope.clickBannerCounter = 0;

        if (angular.isDefined(scope.userInfo) &&
            angular.isDefined(scope.userInfo.biz_data) &&
            angular.isDefined(scope.userInfo.biz_data.mobile_no)) {
                scope.mobileNo = scope.userInfo.biz_data.mobile_no;
        }

        if (!scope.mobileNo) {
            return $location.path('/error/' + appID + "4002");
        }

        scope.showLastedBuild = showLastedBuild;

        scope.preregist = function () {

        rootScope.isLoading = true;

        var config = {
                headers : {
                    'Content-Type': 'application/json'
                }
            };
        var postData = {
             "thaiId"  : scope.userInfo.biz_data.thai_id.replace(/-/g, '')
            };

            $http.post(apiUrl.host + apiUrl.endpoint.profile, postData, config)
                .success(function (res) {

                    rootScope.isLoading = false;

                    var data = {};
                    if(angular.isDefined(res.data)){
                        data = res.data;
                    }

                    if(angular.isDefined(data) && angular.isDefined(data.status_code))
                    {
                      if (data.status_code == "0") {
                        scope.otp();
                      }else if(data.status_code == "1"){
                        scope.register();
                      }else if(data.status_code == "4"){
                        scope.kyc();
                      }else if(data.status_code == "3"){
                        modalFactory({
                          type: "notic",
                          body: 'ERROR.PRE_REGISTER'
                        });
                      }else{
                        modalFactory({
                          type: "notic",
                          body: 'ERROR.PRE_REGISTER_ACCOUNT_FREEZED'
                        });
                      }

                    }else {
                      modalFactory({
                        type: "notic",
                        body: "ERROR.UNKNOWN"
                      });
                    }


                })
                .error(function (response) {
                    errorHandler(response);
                });

        }

        scope.otp = function () {
            $location.path('/otp/login')
        }

        scope.register = function () {
            $location.path('/register')
        }

        scope.kyc = function () {
            $location.path('/kyc')
        }

        scope.showCondition = function(){
          modalFactory({
              type: "register-condition"
            });
        }

        scope.showPrivacy = function(){
          modalFactory({
              type: "register-privacy"
            });
        }

        function showLastedBuild(){
            scope.clickBannerCounter ++;
            if(scope.clickBannerCounter >= 20){
                modalFactory({
                        type: "notic",
                        body: lastedBuild
                });
            }
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .controller('OtpRegisterController', OtpRegisterController);

  /** @ngInject */
  function OtpRegisterController( $rootScope, $scope, $location, OtpService, userInfo, $timeout, webState, errorHandler) {
    var scope = $scope;
    var rootScope = $rootScope;
    if (['NEW_USER_VERIFIED_DOPA_STEP'].indexOf(webState()) === -1) {
      return $location.path('/login');
    }

    scope.userInfo = userInfo();
    scope.invalidOtp = false;
    scope.new_member = true;
    scope.email = $location.search().email;
    rootScope.isLoading = true;

    scope.sendOTP = sendOTP;
    scope.verifyOtp = verifyOtp;

    if (scope.userInfo && scope.userInfo.biz_data && scope.userInfo.biz_data.mobile_no) {
      scope.userPhoneNo = scope.userInfo.biz_data.mobile_no;
      if( angular.isUndefined(scope.userInfo.biz_data.ref_no) || !scope.userInfo.biz_data.ref_no){
        scope.sendOTP(true);
      }else{
        scope.refNumber = scope.userInfo.biz_data.ref_no;
        rootScope.isLoading = false;
      }
    }
    else {
      return $location.path('/register');
    }

    if (!scope.email) {
      return $location.path('/register');
    }

    scope.$watch('otpCode', function () {
      if (scope.invalidOtp==true && scope.otpCode.length == 0) {
        scope.invalidOtp = false;
      }
    });

    function sendOTP(firstTime) {
      scope.otpCode = "";
      scope.userInfo = userInfo();
      scope.invalidOtp = false;
      rootScope.isLoading = true;
      OtpService.sendOtp(scope.userPhoneNo).success(function (data) {
        if (firstTime) {
          scope.refNumber = data.data.otpReference;
          rootScope.isLoading = false;
        } else {
          $timeout(function () {
            scope.refNumber = data.data.otpReference;
            rootScope.isLoading = false;
          }, 1000);
        }
      })
        .error(function (response) {
          errorHandler(response);
        });
    }

    function verifyOtp() {
      rootScope.isLoading = true;
      OtpService.verifyOtpRegister(scope.otpCode, scope.email).success(function (data) {
        if (data.data.status_code && data.data.status_code == "0") {
          rootScope.isLoading = false;
          return $location.path('/consent');

        } else if (data.data.status_code && data.data.status_code != "0") {
          rootScope.isLoading = false;
          $location.search('errorCode', appID + '4005');
          return $location.path('/register');
        }else if (data.data.result == false){
          rootScope.isLoading = false;
          scope.invalidOtp = true;
        }
      })
        .error(function (response) {
          errorHandler(response);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .service('OtpService', OtpService);



  function OtpService($http) {

    var config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    this.sendOtp = sendOtp;
    function sendOtp() {
      var data = {};
      return $http.post(apiUrl.host + apiUrl.endpoint.otp, data, config);
    }

    this.verifyOtp = verifyOtp;
    function verifyOtp(otpCode) {

      var data = {
        "otpCode": otpCode
      };
      
      return $http.post(apiUrl.host + apiUrl.endpoint.otpVerification, data, config);
    }

    this.verifyOtpRegister = verifyOtpRegister;
    function verifyOtpRegister(otpCode, email) {
      var data = {
        "otpCode": otpCode,
        "email": email
      };
      return $http.post(apiUrl.host + apiUrl.endpoint.otpRegisterVerification, data, config);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .controller('OtpController', OtpController);

  /** @ngInject */
  function OtpController( $scope, $rootScope, $location, $stateParams, $timeout, OtpService, userInfo, webState,errorHandler) {

    var scope = $scope;
    var rootScope = $rootScope;

    //Check state
    if(['EXISTING_USER_VERIFIED_DOPA_STEP', 'EXISTING_WITH_KYC_USER'].indexOf(webState()) === -1 ) {
        return $location.path('/login');
    }


    scope.$watch('otpCode', function () {
      if (scope.invalidOtp==true && scope.otpCode.length == 0) {
        scope.invalidOtp = false;
      }
    });

    scope.sendOTP = function(fristTime){
      scope.otpCode = "";
      scope.invalidOtp = false;
      rootScope.isLoading = true;

      OtpService.sendOtp().success(function (data) {

        if (fristTime) {
          scope.refNumber = data.data.otpReference;
          rootScope.isLoading = false;
        } else {
          $timeout(function () {
            scope.refNumber = data.data.otpReference;
            rootScope.isLoading = false;
          }, 1000);
        }

      })
        .error(function (res) {
          errorHandler(res)
        })
    };


    scope.verifyOtp = function(){

      rootScope.isLoading = true;

      OtpService.verifyOtp(scope.otpCode,scope.refNumber).success(function (data) {

        rootScope.isLoading = false;

        if(data.data.result == false) {
          scope.invalidOtp = true;

        }else {
          if(data.data.result){
            if(data.data.status_code == "0") {
              return $location.path('/consent');

            }else if(data.data.status_code == "-2") {
              return $location.path('/kyc').search('alert','fail');
            }else if(data.data.status_code == "-1") {
              return $location.path('/error/' + appID + '5009');
            }
          }
        }
      })
        .error(function (response) {
          errorHandler(response);
        });
    };

    scope.userInfo = userInfo();
    scope.page = $stateParams.page;
    scope.invalidOtp = false;
    scope.new_member = false;

    if( angular.isUndefined(scope.userInfo.biz_data.ref_no) || !scope.userInfo.biz_data.ref_no){
      scope.sendOTP(true);
    }else{
      scope.refNumber = scope.userInfo.biz_data.ref_no;
      rootScope.isLoading = false;
    }



  }
})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .controller('MaintenanceController', MaintenanceController);

  /** @ngInject */
  function MaintenanceController($scope, $rootScope, clientInfo, $location) {

    var scope = $scope;
    var rootScope = $rootScope;
    scope.turnoff = turnoff;
    scope.turnOffMAcount = 0;
    scope.maImage = null;
    scope.clientInfo = clientInfo();
    if (scope.clientInfo) {
      if ( angular.isDefined(scope.clientInfo.client_ma_img) && angular.isDefined(scope.clientInfo.client_ma_img.image_url_auth)) {
        scope.maImage = scope.clientInfo.client_ma_img.image_url_auth;
      }

    }

     function turnoff() {
      scope.turnOffMAcount++;
      if (scope.turnOffMAcount >= 20) {
        rootScope.checkManenance = false;
        return $location.path('/');
      }
    }

  }


})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($rootScope, $scope, $location,clientInfo) {
		var rootScope = $rootScope;
		var scope = $scope;
    var clientInfoData = clientInfo();
		rootScope.isLoading = false;
    
    if(clientInfoData){
      if(angular.isDefined(clientInfoData.onboarding) && angular.isDefined(clientInfoData.onboarding.image) && clientInfoData.onboarding.image.length > 0){
       scope.onBoarding = clientInfoData.onboarding;
      }else{
        return $location.path('/login');
      }
    }else{
      return $location.path('/error/AUT5050');
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('acmAuthorizationWeb')
        .controller('KycController', KycController);

    /** @ngInject */
    function KycController($scope, $rootScope, $location, userInfo,dopaService, modalFactory, webState, errorHandler) {

      //Check state
      if(['EXISTING_WITHOUT_KYC_USER', 'EXISTING_USER_VERIFIED_DOPA_STEP'].indexOf(webState()) === -1)  {
        return $location.path('/login');
      }

      if($location.search().alert){
         showError();
      }

      var scope = $scope;
      var rootScope = $rootScope
      scope.userInfo = userInfo();
      scope.accept = false;
      scope.showCondition = showCondition;
      scope.showPrivacy = showPrivacy;
      
      scope.submitKyc = submitKyc;

      function submitKyc() {
        rootScope.isLoading = true;
        var dopaData = {
          "thaiId": scope.userInfo.biz_data.thai_id.replace(/-/g, ''),
          "title": scope.userInfo.biz_data.title,
          "firstname_th": scope.userInfo.biz_data.first_name,
          "lastname_th": scope.userInfo.biz_data.last_name,
          "laser": scope.userInfo.biz_data.laser.replace(/-/g, ''),
          "birthdate": scope.userInfo.biz_data.date_of_birth
        };

        dopaService.verifyDopa(dopaData).success(function (data) {

          if (data.data.status_code == 0) {
            rootScope.isLoading = false;
            return $location.path('/otp/login')
          } else {
            rootScope.isLoading = false;
            modalFactory({
              type: "notic",
              body: "ERROR.KYC_VERIFY_DOPA_FAIL"
            });
          }
        })
          .error(
          function (response) {
            errorHandler(response);
          });
      }

      function showCondition(){
      modalFactory({
          type: "register-condition"
        });
    }

      function showPrivacy(){
        modalFactory({
            type: "register-privacy"
          });
      }
      
      function showError() {
        modalFactory({
          type: "notic",
          body: "ERROR.UNKNOWN"
        });
      }

    }
})();

(function() {
  'use strict';

  angular
      .module('acmAuthorizationWeb')
      .service('dopaService', dopaService);

  function dopaService($http) {

    var config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    this.verifyDopa = verifyDopa;
    function verifyDopa(data) {
      return $http.post(apiUrl.host + apiUrl.endpoint.verifyDopa, data, config);
    }

  }



})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .controller('ErrorController', ErrorController);

  /** @ngInject */
  function ErrorController($scope, $stateParams) {
    var scope = $scope;
    scope.errorCode = $stateParams.code;
  }
})();


(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .controller('ConsentController', ConsentController);

  /** @ngInject */
  function ConsentController($timeout,$location,$rootScope, $scope,modalFactory, $httpParamSerializer, userInfo, webState, clientInfo) {

    var scope = $scope;
    var rootScope = $rootScope;

    //Check state
    if(['OTP'].indexOf(webState()) === -1) {
      return $location.path('/login');
    }

    scope.userInfo = userInfo();
    var clientInfoData = clientInfo();
    scope.postUrl = "";
    scope.formId = "#oauth2-form";
    scope.allow = allow;
    scope.showCancel = showCancel;
    scope.clicked = false;
    rootScope.isLoading = false;

    scope.appName = clientInfoData.app_display_name;
    scope.logo = clientInfoData.logo;
    scope.termcond = clientInfoData.term_and_con;

    function allow(access) {

      access = (typeof access !== 'undefined') ?  access : false;

      rootScope.isLoading = true;
      scope.clicked = true;

      submitConsent(access);

    }
    function submitConsent(access){
      var params = {
        redirect_uri: scope.userInfo.redirect_uri,
        state: scope.userInfo.state,
        scope: scope.userInfo.scope,
        response_type: scope.userInfo.response_type,
        client_id: scope.userInfo.client_id,
        biz_data: scope.userInfo.biz_data,
        submit_access: access
      };
      var queryString = $httpParamSerializer(params);
      scope.postUrl = apiUrl.host + apiUrl.endpoint.approve + "?" + queryString;
      angular.element(scope.formId).attr('action', scope.postUrl);
      angular.element(scope.formId).submit();
    }

    function showCancel(){
      modalFactory({
          type: "cancelConsent",
          allow: scope.allow
        });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .run(runBlock);
  /** @ngInject */
  function runBlock($rootScope, $window, $location, userAgent, clientInfo) {

    var dataLayer = $window.dataLayer = $window.dataLayer || [];

    var rootScope = $rootScope;
    rootScope.isLoading = false;
    rootScope.useragent = userAgent();
    rootScope.checkManenance = true;

  
    var deregisterationCallback = $rootScope.$on('$stateChangeSuccess', function () {

    var clientInfoData = clientInfo();
    if(clientInfoData){
      if(angular.isDefined(clientInfoData.client_ma_is_active) && clientInfoData.client_ma_is_active == true&&rootScope.checkManenance ==true){
        return $location.path('/maintenance');
      }
    }

      dataLayer.push({
        event: 'ngPageChange',
        attributes: {
          app: clientInfo().name,
          route: $location.path()
        }
      });
    });
    $rootScope.$on('$destroy', deregisterationCallback);
  }

})();

(function () {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('preregister', {
        url: '/login',
        templateUrl: 'app/preregister/preregister.html',
        controller: 'PreregisterController',
        controllerAs: 'preregister'
      })
      .state('kyc', {
        url: '/kyc',
        templateUrl: 'app/kyc/kyc.html',
        controller: 'KycController',
        controllerAs: 'kyc'
      })
      .state('otp_login', {
        url: '/otp/login',
        templateUrl: 'app/otp/otp.html',
        controller: 'OtpController',
        controllerAs: 'otp'
      })
      .state('otp_register', {
        url: '/otp/register',
        templateUrl: 'app/otp/otp.html',
        controller: 'OtpRegisterController',
        controllerAs: 'otpRegister'
      })
      .state('consent', {
        url: '/consent',
        templateUrl: 'app/consent/consent.html',
        controller: 'ConsentController',
        controllerAs: 'consent'
      })
      .state('register', {
        url: '/register',
        templateUrl: 'app/register/register.html',
        controller: 'RegisterController',
        controllerAs: 'register'
      })
      .state('error', {
        url: '/error/:code',
        templateUrl: 'app/error/error.html',
        controller: 'ErrorController',
        controllerAs: 'error'
      })
      .state('maintenance', {
        url: '/maintenance',
        templateUrl: 'app/maintenance/maintenance.html',
        controller: 'MaintenanceController',
        controllerAs: 'maintenance'
      });
      $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('acmAuthorizationWeb')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider, $translateProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    //
    $httpProvider.defaults.withCredentials = true;

    $translateProvider.translations('th', translationsTH);
    // $translateProvider.translations('en', translationsDE);
    $translateProvider.preferredLanguage('th');
    $translateProvider.useSanitizeValueStrategy('sanitize');

  }

})();

angular.module("acmAuthorizationWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/consent/consent.html","<div class=wrapper><div class=wrapper-inner><div class=oauth-box><div class=oauth-head-box><div class=logo-box><span class=partner-logo><img ng-src=\"{{logo}}?_=1674618986084\" alt=\"\"> </span><span class=wallet-logo><img ng-src=\"../../assets/images/logo_tmnw.png?_=1674618986084\" alt=\"\"></span></div><div class=header-box>{{appName}} กำลังเชื่อมต่อกับ<br>บัญชี TrueMoney Wallet ของคุณ</div></div><div class=oauth-info-box><div class=btn-box><form id=oauth2-form ng-action={{postUrl}} method=POST enctype=application/x-www-form-urlencoded><button type=submit class=\"btn btn-onewallet\" ng-click=allow(true) ng-disabled=clicked>ดำเนินการต่อ</button></form><div class=cancel-box><a id=cancel-consent href=javascript:void(0) ng-click=showCancel()>ยกเลิก</a></div></div></div></div></div></div>");
$templateCache.put("app/error/error.html","<div class=wrapper-inner><div class=errorpage-box><div class=txt-box><div class=logo-box><img src=../assets/images/Error_icon@2x.png></div><div class=info-box><h2>ไม่สามารถทำรายการได้ในขณะนี้</h2><p>กรุณากลับสู่หน้าหลัก<br>เพื่อทำรายการใหม่อีกครั้ง</p><p><span class=topup-text-gray>Response Code : {{errorCode}} </span></p></div></div><!-- <div class=\"btn-box\">\n                <button type=\"submit\" name=\"\" class=\"btn btn-onewallet\">กลับสู่หน้าหลัก</button>\n        </div> --><!--/btn-box--></div><!--/oauth-box--></div>");
$templateCache.put("app/kyc/kyc.html","<div class=wrapper><div class=wrapper-inner><div class=create-wallet-box><div class=header-box><p><strong>ยืนยันตัวตน</strong><br>กรุณากรอกข้อมูลเพิ่มเติม<br>เพื่อยืนยันความเป็นเจ้าของบัญชี</p></div><form name=kyc><fullname title=userInfo.biz_data.title firstname=userInfo.biz_data.first_name lastname=userInfo.biz_data.last_name accept=acceptTermAndCon></fullname><dob date=userInfo.biz_data.date_of_birth accept=acceptTermAndCon></dob><thai-id name=thai-id label=เลขบัตรประจำตัวประชาชน thaiid=userInfo.biz_data.thai_id accept=acceptTermAndCon></thai-id><laser-valid laser=userInfo.biz_data.laser accept=acceptTermAndCon></laser-valid><button class=\"btn btn-onewallet\" ng-disabled=!kyc.$valid ng-click=submitKyc() id=submit-btn>ยืนยัน</button></form></div></div></div>");
$templateCache.put("app/main/main.html","<div class=wrapper><div class=content-area><carousel id=myCarousel class=\"carousel slide\" items=onBoarding></carousel></div></div>");
$templateCache.put("app/maintenance/maintenance.html","<div class=wrapper><img ng-src={{maImage}} class=ma-image ng-click=turnoff()></div>");
$templateCache.put("app/otp/otp.html","<div class=wrapper><div class=wrapper-inner><div class=confirm-otp-box><div class=header-box><p ng-hide=new_member><strong>คุณมีบัญชีทรูมันนี่ วอลเล็ทอยู่แล้ว</strong></p><p>กรุณากรอกรหัส OTP จาก SMS ของคุณ เพื่อยืนยันการใช้งาน</p></div><form name=otp><div class=form-group ng-class=\"invalidOtp ? \'has-error\' : \'\'\"><input autocomplete=off name=otpCode type=tel maxlength=6 class=form-control placeholder=\"กรอกรหัส OTP 6 หลัก\" ng-model=otpCode> <span class=block-ref>REF : <span class=ref-number>{{refNumber}}</span></span> <span class=help-block ng-if=invalidOtp translate>OTP.INVALID</span></div><div class=info-box><div class=text-right>ไม่ได้รับ? <a href=javascript:void(0) ng-click=sendOTP()>กดรับ OTP อีกครั้ง</a></div></div></form></div><div class=wrap-btn-submit><button class=\"btn btn-onewallet\" ng-disabled=\"otpCode.length<6 || !otp.otpCode.$dirty\" ng-click=verifyOtp()>ยืนยัน</button></div></div></div>");
$templateCache.put("app/preregister/preregister.html","<div class=\"wrapper pre\"><div class=\"wrapper-inner pre_register\"><div ng-if=\"topBaner != \'\'\" class=banner-wallet><img ng-click=showLastedBuild() ng-src={{topBaner}}></div><form name=registration_by_cardid><div class=wrapper-inner><thai-id label=เริ่มใช้งานเพียงกรอกเลขบัตรประชาชน thaiid=userInfo.biz_data.thai_id info=true></thai-id><div class=telephone>เบอร์โทรศัพท์ของคุณ <span class=telephone-number>{{mobileNo | tel}}</span></div><div class=wrap-btn-submit><button id=pre-login type=button ng-disabled=\"!(registration_by_cardid.$valid&&userInfo.biz_data.thai_id.length==17 && acceptTermAndCon)\" class=\"btn btn-onewallet\" name=registration_button ng-click=preregist()>เริ่มใช้งาน</button></div><div class=form-group><div class=\"no-padding policy-txt\"><div class=accept-policy><input type=checkbox name=accept value=true ng-model=acceptTermAndCon ng-init=\"acceptTermAndCon=true\"></div>ยอมรับ <a id=termandcond ng-click=showCondition()>ข้อกำหนดและเงื่อนไขการให้บริการ</a> และ <a id=privacypolicy ng-click=showPrivacy()>นโยบายความเป็นส่วนตัว</a> ของบริษัท ทรูมันนี่ จำกัด<p>{{policyTxt}}</p></div></div></div></form></div></div>");
$templateCache.put("app/register/register.html","<div class=wrapper><div class=wrapper-inner><div class=create-wallet-box><div class=header-box><strong>สร้างบัญชี Wallet</strong></div><form name=register><fullname title=userInfo.biz_data.title firstname=userInfo.biz_data.first_name lastname=userInfo.biz_data.last_name></fullname><dob date=userInfo.biz_data.date_of_birth></dob><thai-id label=เลขบัตรประจำตัวประชาชน thaiid=userInfo.biz_data.thai_id></thai-id><laser-valid laser=userInfo.biz_data.laser></laser-valid><email email=email invalid=invalidEmail></email><button class=\"btn btn-onewallet\" ng-click=submitRegister() ng-disabled=\"invalidEmail || register.$invalid || userInfo.biz_data.laser.length < 14\" id=submit-btn>ยืนยัน</button></form></div></div></div>");
$templateCache.put("app/components/modal/backid.html","<div class=modal-body><p class=text-center><img src=\"../assets/images/backid_num.png?_=1674618986084\" alt=\"\" style=\"width: 100%;height: auto\"></p><p class=text-center>กรุณากรอกเลขเลเซอร์ 12 หลัก<br>หลังบัตรประจำตัวประชาชน<br>เพื่อตรวจสอบกับระบบข้อมูลทะเบียนกลาง</p></div><div class=modal-footer ng-click=closeBackidModal()><div class=text-center><a data-dismiss=modal aria-label=Close>ตกลง</a></div></div>");
$templateCache.put("app/components/modal/consent-app-term-and-cond.html","<div class=\"modal-header disalbe-user-select\"><button ng-click=closeConsentTermAndCondModal() type=button class=close data-dismiss=modal aria-label=Close><i class=\"fa fa-times\" aria-hidden=true></i></button><h4 class=\"modal-title disalbe-user-select\" id=myModalLabel>ข้อกำหนดและเงื่อนไขการใช้บริการ</h4></div><div class=\"modal-body disalbe-user-select\" translate>{{termcond}}</div><div class=faded-scroller></div><div class=modal-footer ng-click=closeConsentTermAndCondModal()><div class=text-center><a data-dismiss=modal aria-label=Close>ปิด</a></div></div>");
$templateCache.put("app/components/modal/consent-cancel.html","<div class=\"modal-body text-center\"><p><strong>ต้องการยกเลิกการเชื่อมต่อ</strong></p>หากคุณยกเลิก<br>คุณจะไม่สามารถดำเนินการต่อได้</div><div class=\"modal-footer modal-col\" ng-click=closeCancelConsent()><div class=\"col-xs-6 cursor-pointer\" ng-click=closeCancelConsent() data-dismiss=modal aria-label=Close><a href=javascript:void(0) class=text-color-gray>ไม่ต้องการ</a></div><div class=\"col-xs-6 cursor-pointer\" ng-click=allow(false)><a href=javascript:void(0)>ต้องการ</a></div></div>");
$templateCache.put("app/components/modal/info.html","<div class=\"modal-body text-center disalbe-user-select\"><p translate>{{modalInfo}}</p></div><div class=modal-footer ng-click=closeInfoModal()><a data-dismiss=modal aria-label=Close>ตกลง</a></div>");
$templateCache.put("app/components/modal/notic.html","<div class=\"modal-body text-center disalbe-user-select\" translate>{{modalBody}}</div><div class=modal-footer ng-click=closeNoticModal()><a data-dismiss=modal aria-label=Close>ตกลง</a></div>");
$templateCache.put("app/components/modal/register-condition.html","<div class=\"modal-header disalbe-user-select\"><button ng-click=closeRegisterConditionModal() type=button class=close data-dismiss=modal aria-label=Close><i class=\"fa fa-times\" aria-hidden=true></i></button><h4 class=modal-title id=myModalLabel>เงื่อนไขการให้บริการแอพพลิเคชั่น TrueMoney Wallet</h4></div><div class=\"modal-body disalbe-user-select\"><p>เงื่อนไขการให้บริการนี้เป็นข้อตกลงระหว่าง บริษัท ทรู มันนี่ จํากัด ซึ่งต่อไปนี้จะเรียกว่า “<strong>บริษัท</strong>” ฝ่ายหนึ่ง กับ “<strong>ผู้ใช้บริการ</strong>” อีกฝ่ายหนึ่ง เพื่อใช้บริการแอพพลิเคชั่น <strong>TrueMoney Wallet</strong> ซึ่งต่อไปนี้จะเรียกว่า “<strong>บริการ</strong>” โดยผู้ใช้ บริการสามารถทําธุรกรรมการเงินด้วยเงินอิเล็กทรอนิกส์ของบริษัท ทั้งการเติม-จ่าย-โอน-ถอน ได้อย่างสะดวกจากโทรศัพท์เคลื่อนที่ ตามรายละเอียดที่ปรากฏในเงื่อนไขการให้บริการแอพพลิเคชั่น TrueMoney Wallet ซึ่งต่อไปนี้จะเรียกว่า “<strong>เงื่อนไขการให้บริการ</strong>” โดยเงื่อนไขการให้บริการนี้อาจมีลักษณะกระทบสิทธิของผู้ใช้บริการ ซึ่งผู้ใช้บริการควรอ่านและทําความเข้าใจอย่างละเอียดและหากมีข้อสงสัยเกี่ยวกับบริการของบริษัท ผู้ใช้บริการสามารถติดต่อสอบถามได้โดยทันที</p><strong>1. ข้อกําหนดทั่วไป</strong><p>1.1 ผู้ใช้บริการตกลงที่จะปฏิบัติและผูกพันตามเงื่อนไขการใช้บริการ ซึ่งการใช้บริการของผู้ใช้บริการถือเป็นการยอมรับเงื่อนไขการให้บริการนี้ โดยบริษัทอาจแก้ไขหรือเพิ่มเติมเงื่อนไขการให้บริการได้ไม่ว่าในเวลาใดโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า และการที่ผู้ใช้บริการใช้บริการต่อไปภายหลังจากที่มีการแก้ไขหรือเพิ่มเติมดังกล่าว ย่อมถือเป็นการยอมรับการแก้ไขในแต่ละครั้ง</p><p>1.2 เว้นแต่จะได้มีการแจ้ง หรือกําหนดไว้เป็นอย่างอื่น คุณลักษณะใหม่ๆ ที่ได้เพิ่มเติม ปรับปรุง หรือแก้ไขในบริการให้ ถือว่าอยู่ภายใต้เงื่อนไขการให้บริการฉบับนี้ทั้งสิ้น</p><p>1.3 บริษัทสงวนสิทธิ์ในการปรับปรุงหรือยกเลิกการบริการ หรือส่วนใดส่วนหนึ่งของบริการไม่ว่าจะเป็นการชั่วคราว หรือตลอดไปได้ตลอดเวลาโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า</p><strong>2. การใช้บริการ</strong><p>2.1 ผู้ใช้บริการต้องกรอกชื่อ-นามสกุล หรือที่อยู่ไปรษณีย์ อิเล็กทรอนิกส์-รหัสผ่าน หรือหมายเลขโทรศัพท์เคลื่อนที่ใน การสมัครใช้บริการ และผู้ใช้บริการจะต้องระบุหมายเลขบัตรประจําตัวประชาชนของตนเอง รวมทั้งข้อมูลอื่นๆ ตามที่บริษัทกำหนด หรือจะกำหนดต่อไปเพื่อให้เป็นไปตามกฎหมายกฎหมายที่เกี่ยวข้อง และกําหนดรหัสผ่าน (Password) ของตนเอง (ซึ่งต่อไปนี้จะเรียกว่า “รหัสผ่าน”) เพื่อใช้ในการทํารายการต่างๆอันเกี่ยวเนื่องกับการใช้บริการ โดยผู้ใช้บริการสามารถแก้ไขเปลี่ยนแปลงรหัสผ่านนี้ได้เองในภายหลังตามข้อกําหนดและเงื่อนไขของบริษัท ทั้งนี้ บริษัทขอสงวนสิทธิ์ในการเปิดใช้บริการ, ให้บริการ และ/หรือทำธุรกรรมกับผู้ใช้บริการที่ปกปิดชื่อจริง หรือใช้นามแฝง หากบริษัทตรวจพบว่าชื่อที่ผู้ใช้บริการลงทะเบียนไว้เป็นชื่อที่ไม่ถูกต้องและเป็นจริง</p><p>2.2 ผู้ใช้บริการจะต้องเก็บรักษารหัสผ่านนี้ไว้เป็นความลับเฉพาะตัวของผู้ใช้บริการเท่านั้น ผู้ใช้บริการยอมรับว่าหากมีการทํารายการใดๆ โดยใช้รหัสผ่านของผู้ใช้บริการ ให้ถือว่าเป็นการกระทําโดยตัวของผู้ใช้บริการเองทุกประการ โดยบริษัทไม่ต้องรับผิดชอบในความเสียหายที่เกิดขึ้นจากการทํารายการใดๆ ภายใต้บัญชีของผู้ใช้บริการจากการใช้รหัสผ่านดังกล่าว</p><p>2.3 ในกรณีที่ผู้ใช้บริการใช้รหัสผ่านทํารายการใดๆ อันเกี่ยวเนื่องกับการใช้บริการเสร็จสิ้นสมบูรณ์แล้ว ผู้ใช้บริการยอมรับว่าไม่สามารถยกเลิก เพิกถอน เปลี่ยนแปลง หรือ แก้ไขรายการดังกล่าวได้ และผู้ใช้บริการต้องผูกพันตามรายการดังกล่าวทุกประการ</p><p>2.4 ผู้ใช้บริการสามารถใช้รหัสผ่านสําหรับการใช้บริการชําระเงินค่าสินค้า ค่าบริการ รวมทั้งการทําธุรกรรมต่างๆ ด้านการเงิน การธนาคาร และ/หรือการทําธุรกรรมใดๆ ซึ่งบริษัทอาจจะขยายขอบเขตการให้บริการต่อไปในภายหน้า</p><p>2.5 ผู้ใช้บริการรับทราบว่า ในการใช้บริการหากมีการป้อนรหัสผ่านผิดติดต่อกันมากกว่าจํานวนครั้งที่บริษัทกําหนด บริษัทจะระงับการใช้บริการโดยอัตโนมัติทันที ผู้ใช้บริการจะสามารถใช้บริการนี้ต่อไปได้ก็ต่อเมื่อแจ้งความจํานงให้บริษัทดําเนินการตามวิธีอื่นใดที่บริษัทกําหนดเพื่อขอออกรหัสผ่านใหม่</p><p>2.6 ในกรณีที่ผู้ใช้บริการลืมรหัสผ่าน หรือต้องการเปลี่ยนแปลงรหัสผ่านไม่ว่าด้วยเหตุใดๆ ผู้ใช้บริการต้องดําเนินการแจ้งให้บริษัททราบทันทีตามวิธีการอื่นใดที่บริษัทกําหนด อย่างไรก็ตาม การดําเนินการต่างๆ ข้างต้นจะไม่มีผลกระทบต่อการทําธุรกรรมใดๆ ที่ได้ดําเนินการไปแล้วก่อนการแจ้งให้บริษัททราบ</p><p>2.7 ผู้ใช้บริการตกลงยินยอมชําระค่าธรรมเนียมการใช้บริการตามอัตราที่บริษัทกําหนดเรียกเก็บ ทั้งนี้บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงอัตราค่าธรรมเนียมได้โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า</p><p>2.8 ผู้ใช้บริการรับทราบว่าการให้บริการต่างๆนี้ บริษัทเป็นเพียงผู้ให้บริการในการอํานวยความสะดวกในการซื้อสินค้า บริการ และ/หรือรับชําระค่าสินค้าค่าบริการ และทําธุรกรรมตามคําสั่งของผู้ใช้บริการ ดังนั้นหากมีปัญหากับการใช้สินค้า/บริการ หรือมีความชํารุดบกพร่องของสินค้า/บริการ หรือเกิดข้อพิพาทใดๆ ผู้ใช้บริการต้องดําเนินการติดต่อกับผู้ขาย หรือผู้ให้บริการของสินค้า/บริการเหล่านั้นด้วยตนเอง</p><p>อนึ่ง ในการให้บริการรับชําระค่าสินค้า/ค่าบริการ บริษัทไม่มีส่วนรู้เห็นในสัญญา ข้อกําหนด หรือสิทธิและหน้าที่ต่างๆ ซึ่งผู้ใช้บริการและเจ้าของสินค้า/ผู้ให้บริการมีต่อกัน ดังนั้นหากมีข้อพิพาทอันเนื่องมาจากการให้บริการรับชําระค่าสินค้า/บริการของบริษัทเกิดขึ้น ไม่ว่าจะเป็นการชําระหนี้เกินกําหนด การชําระหนี้เพียงบางส่วน การถูกระงับการให้บริการ หรือกรณีอื่นใด ผู้ใช้บริการจะต้องเป็นผู้รับผิดชอบและ/หรือดําเนินการแก้ไขข้อพิพาทด้วยตนเอง โดยไม่เกี่ยวข้องกับบริษัทแต่อย่างใด</p><p>2.9 บริษัทสงวนสิทธิ์ในการปฏิเสธการทํารายการชำระหรือรับชําระค่าสินค้า/ค่าบริการ ดังต่อไปนี้</p><p>2.9.1 การทํารายการชำระหรือรับชําระค่าสินค้า/ค่าบริการในนามนิติบุคคล หรือบุคคลอื่นๆ</p><p>2.9.2 การทํารายการชำระหรือรับชําระค่าสินค้า/ค่าบริการบางประเภทซึ่งถูกระงับการให้บริการและมีค่าธรรมเนียมการต่อสายสัญญาณ</p><p>2.9.3 การทํารายการชำระหรือรับชําระค่าสินค้า/ค่าบริการบางประเภทซึ่งมีหนี้ค้างชําระและเกินกําหนดชําระ</p><p>2.9.4 การทํารายการชำระหรือรับชําระค่าสินค้า/ค่าบริการบางประเภทซึ่งเป็นการชําระเพียงบางส่วน</p><p>2.9.5 การทำรายการชำระหรือรับชำระสินค่าสินค้า/ค่าบริการซึ่งขัดต่อกฎหมายหรือขัดต่อศีลธรรมอันดี</p><p>2.9.6 การทำรายการชำระหรือรับชำระค่าสินค้า/ค่าบริการเกินจำนวนรายการที่บริษัทกำหนดต่อเดือน ทั้งนี้ เงื่อนไขในการชําระค่าสินค้า/ค่าบริการเป็นไปตามข้อ กําหนดของเจ้าของสินค้า/ผู้ให้บริการแต่ละราย</p><p>2.10 กรณีที่บริษัทตรวจพบว่า เงินในบัญชีทรูมันนี่ ของผู้ใช้บริการมีไม่เพียงพอชําระค่าสินค้าและ/หรือค่าบริการ หรือจํานวนเงินค่าสินค้าและ/หรือค่าบริการเกินกว่าวงเงินที่บริษัทกําหนดไว้สําหรับผู้ใช้บริการในครั้งใด บริษัทมีสิทธิระงับการให้บริการแก่ผู้ใช้บริการในครั้งนั้น</p><p>2.11 บริษัทจะให้บริการอย่างดีที่สุดเพื่อให้ผู้ใช้บริการได้รับบริการที่พึงพอใจ ดังนั้น หากการให้บริการใดๆ ของบริษัทเกิดความผิดพลาด ล่าช้า ไม่ว่าเกิดขึ้นจากระบบคอมพิวเตอร์ ระบบอินเตอร์เน็ต อุปกรณ์อิเล็กทรอนิกส์ต่างๆ หรือระบบอื่นใดที่เกี่ยวข้องกับการให้บริการนี้ รวมทั้งระบบเครือข่ายโทรศัพท์เคลื่อนที่ และไม่ว่าจะเกิดจากเหตุใดๆ ผู้ใช้บริการตกลงไม่ยกเอาเหตุขัดข้องดังกล่าวมาเป็นข้อเรียกร้องค่าเสียหายใดๆ จากบริษัท</p><p>2.12 บริษัทจะไม่รับผิดชอบในทุกกรณีต่อความสูญหาย หรือเสียหาย ไม่ว่าจะโดยทางตรง หรือโดยทางอ้อมอันเกิดขึ้นกับข้อมูลในโทรศัพท์เคลื่อนที่ หรือโทรศัพท์เคลื่อนที่ หรืออุปกรณ์อื่นใดอันเป็นผลมาจากการใช้บริการนี้</p><p>2.13 กรณีที่บริษัทตรวจพบว่าเงินในบัญชี (TrueMoney Wallet) ของผู้ใช้บริการไม่มีการเคลื่อนไหวใดๆ ภายในระยะเวลา 1 ปี นับจากวันที่ใช้บริการครั้งล่าสุด บริษัทสงวนสิทธิ์ในการคิดค่าธรรมเนียมใดๆ (ถ้ามี) จากผู้ใช้บริการ รวมทั้งดําเนินการใดๆ ตามที่บริษัทเห็นสมควร</p><p>2.14 กรณีที่บริษัทตรวจพบว่าบัญชีของผู้ใช้บริการมีการทำรายการธุรกรรมที่มีลักษณะไม่พึงคล้ายการทำธุรกรรมสำหรับบุคคลทั่วไป บริษัทขอสงวนสิทธิในการระงับการใช้บริการของผู้ใช้บริการชั่วคราว เพื่อตรวจสอบการทำรายการของผู้ใช้บริการ และเมื่อตรวจสอบพบว่าผู้ใช้บริการนำบัญชี (TrueMoney Wallet) ไปใช้ในลักษณะตัวแทนรับชำระเงิน หรือ ประกอบธุรกิจในรูปแบบต่างๆ ที่ไม่ใช่การดำเนินการในรูปแบบบุคคลธรรมดา บริษัทขอสงวนสิทธิในการระงับ และ/หรือยกเลิกการใช้บริการของผู้ใช้บริการ ทั้งนี้ บริษัทไม่มีส่วนเกี่ยวข้องหรือรับผิดชอบในความเสียหายทั้งหมด ที่จะเกิดขึ้น</p><p>2.15 ตามพระราชบัญญัติการป้องกันและปรามปรามการฟอกเงิน พ.ศ. 2542 รวมถึงประกาศ หลักเกณฑ์ที่เกี่ยวข้องที่มีผลใช้บังคับอยู่ในปัจจุบันและ/หรือที่จะมีผลใช้บังคับในภายหน้า บริษัทซึ่งเป็นผู้ประกอบธุรกิจเงินอิเล็กทรอนิกส์ มีหน้าที่ต้องปฏิบัติตามกฎหมายการป้องกันและปราบปรามการ ฟอกเงินและการต่อต้านการสนับสนุนทางการเงินแก่การก่อการร้าย โดยการจัดให้ผู้ใช้บริการแสดงตัวตนโดยทําการลงทะเบียนและแสดงหลักฐานข้อมูลที่ครบถ้วนและถูกต้องตามที่กฎหมายกําหนด หากผู้ใช้บริการไม่ดําเนินการลงทะเบียนหรือแสดงหลักฐานภายในระยะเวลาที่กําหนดดังกล่าว ผู้ใช้บริการยินยอมให้บริษัทระงับการใช้บริการ หรืองดเว้นการทำธุรกรรมของผู้ใช้บริการชั่วคราว หรือดําเนินการอื่นใดจนกว่าผู้ใช้บริการจะลงทะเบียนและแสดงหลักฐานข้อมูลที่ครบถ้วนและถูกต้องตามแบบที่กฎหมายหรือสํานักงานปปง. กําหนด</p><p>2.16 บริษัทสงวนสิทธิ์ ในการเปลี่ยนแปลงเกณฑ์การพิจารณาอนุมัติ และการจำกัดจำนวนกระเป๋าเงินอิเล็กทรอนิกส์ ต่อ 1 หมายเลขบัตรประจำตัวประชาชน ตามที่บริษัทเห็นสมควร โดยไม่จำเป็นต้องแจ้งเหตุผลให้ผู้ใช้บริการทราบ</p><p>2.17 ผู้ใช้บริการรับทราบว่า ในกรณีดังต่อไปนี้ ผู้ใช้บริการจะไม่สามารถทำธุรกรรมใดๆ กับบัญชีทรูมันนี่ของผู้ใช้บริการได้</p><p>2.17.1 หมายเลขโทรศัพท์เคลื่อนที่ของผู้ใช้บริการที่ลงทะเบียนไว้กับบัญชีทรูมันนี่ถูกระงับบริการ ผู้ใช้บริการจะไม่สามารถทำธุรกรรมใดๆ กับบัญชีทรูมันนี่ของผู้ใช้บริการได้ จนกว่าการระงับบริการจะถูกยกเลิก</p><p>2.17.2 ผู้ใช้บริการเปลี่ยนหมายเลขโทรศัพท์เคลื่อนที่ที่ลงทะเบียนไว้กับบัญชีทรูมันนี่ของบริษัท หรือยกเลิกการใช้หมายเลขโทรศัพท์เคลื่อนที่ที่ลงทะเบียนไว้กับบัญชีทรูมันนี่หรือหมายเลขโทรศัพท์เคลื่อนที่ดังกล่าวถูกยกเลิกด้วยเหตุผลอื่นใด<br>ในกรณีดังกล่าวข้างต้น ผู้ใช้บริการรับทราบว่า ผู้ใช้บริการจะต้องนำเงินออกจากบัญชีทรูมันนี่ของผู้ใช้บริการก่อนเปลี่ยนหมายเลขโทรศัพท์เคลื่อนที่ หรือก่อนหมายเลขโทรศัพท์เคลื่อนที่ดังกล่าวจะถูกระงับ หรือถูกยกเลิก และปิดบัญชีทรูมันนี่ มิฉะนั้น บริษัทจะไม่รับผิดชอบในความเสียหายใด ๆ ที่อาจเกิดขึ้นกับผู้ใช้บริการ</p><p>2.18 บริษัทไม่รับผิดชอบในความเสียหาย หรือความสูญหายที่เกิดกับเงินอิเล็กทรอนิกส์ในบัญชี (TrueMoney Wallet) อันเนื่องจากโทรศัพท์เคลื่อนที่หรืออุปกรณ์อื่นใดของผู้ใช้บริการสูญหาย ถูกขโมย ถูกหลอกลวง หรือจากเหตุสุดวิสัยอื่นใด โดยผู้ใช้บริการจะต้องแจ้งระงับการใช้เงินในบัญชี (TrueMoney Wallet) ต่อบริษัททันที โดยแจ้งความประสงค์ขอระงับการใช้เงินในบัญชี (TrueMoney Wallet) ด้วยตนเองทางโทรศัพท์มายังหมายเลข 3333 หรือ 02-647-3333 หรือ สามารถแจ้งความประสงค์ได้ที่สาขาของบริษัท (ตามรายละเอียดในข้อ 4.1)</p><p>2.19 บริษัทไม่รับผิดชอบในความเสียหาย หรือความสูญหายที่เกิดกับเงินในบัญชี (TrueMoney Wallet) อันเนื่องจาก Malware หรือ computer virus หรือจากการโจมตีทางอิเล็กทรอนิกส์อื่นใด บนโทรศัพท์เคลื่อนที่ หรืออุปกรณ์อื่นใดของผู้ใช้บริการที่ใช้บริการเงินในบัญชี (TrueMoney Wallet)</p><p><strong>3.ข้อกำหนดและเงื่อนไขการใช้บริการ การโอนเงินเข้าบัญชีธนาคาร</strong></p><p>3.1 ผู้ใช้บริการจะต้องทำรายการผ่านเว็บไซต์หรือแอพพลิเคชั่น เพื่อขอโอนเงินจากบัญชีทรูมันนี่ เข้าบัญชีธนาคารที่ผู้ใช้บริการระบุ ตามขั้นตอนและวิธีการที่บริษัทกำหนด</p><p>3.2 ผู้ใช้บริการรับทราบและยอมรับว่าในการโอนเงินจากบัญชีทรูมันนี่ เข้าบัญชีธนาคารที่ผู้ใช้บริการระบุ จะมีอัตราค่าธรรมเนียมตามอัตราที่บริษัทได้ประกาศให้ผู้ใช้บริการทุกท่านได้รับทราบ โดยค่าธรรมเนียมดังกล่าวจะถูกหักจากเงินในบัญชีทรูมันนี่ของผู้ใช้บริการทันทีที่ผู้ใช้บริการแจ้งขอโอนเงิน หากมีการเปลี่ยนแปลงอัตราค่าธรรมเนียมดังกล่าว บริษัทจะแจ้งให้ผู้ใช้บริการทราบล่วงหน้าตามวิธีการที่บริษัทกำหนด</p><p>3.3 จำนวนเงินที่สามารถทำการโอนได้ต่อครั้งจะขึ้นอยู่กับประเภทของบัญชีทรูมันนี่</p><p>3.4 ผู้ใช้บริการสามารถทำรายการนำเงินออกจากบัญชีทรูมันนี่ได้ไม่เกินจำนวนเงินที่กำหนดไว้ต่อวัน ขึ้นอยู่กับประเภทของบัญชีทรูมันนี่</p><p>3.5 ผู้ใช้บริการไม่สามารถขอยกเลิกคำร้องขอโอนเงินได้</p><p>3.6 กรณีที่บริษัทตรวจพบว่า เงินในบัญชีทรูมันนี่ของผู้ใช้บริการมีจำนวนไม่เพียงพอกับจำนวนเงินที่ขอโอนเงิน และค่าธรรมเนียมการทำรายการโอนเงิน บริษัทขอสงวนสิทธิ์ในการระงับการให้บริการแก่ผู้ใช้บริการในครั้งนั้นๆ</p><p>3.7 หากการให้บริการของบริษัทมีเหตุขัดข้อง เนื่องจากระบบของธนาคาร บริษัทจะทำการคืนเงินเข้าบัญชีทรูมันนี่ของผู้ใช้บริการโดยอัตโนมัติภายใน 3 วันทำการ หลังจากได้รับแจ้งจากธนาคาร</p><p>3.8 กรณีที่ผู้ใช้บริการส่งคำร้องขอโอนเงินแล้วและมีการขอยกเลิกรายการโอนเงิน หรือกรณีอื่นใดที่เกิดจากความประมาทเลินเล่อของผู้ใช้บริการเองที่ทำให้ไม่สามารถโอนเงินได้ ผู้ใช้บริการรับทราบว่าบริษัทจะไม่คืนค่าธรรมเนียมในการทำรายการดังกล่าว เว้นแต่กรณีที่ไม่สามารถโอนเงินได้เกิดจากเหตุขัดข้องจากระบบของบริษัท หรือธนาคารเท่านั้น</p><p>3.9 ผู้ใช้บริการสามารถสอบถามข้อมูลบริการ ตรวจสอบการทำรายการและ/หรือแจ้งปัญหาในการใช้บริการได้ที่ศูนย์ลูกค้าสัมพันธ์ หมายเลข 02-647-3333 หรือช่องทางอื่นใดที่บริษัทกำหนดไว้</p><p><strong>4. การยกเลิกการใช้บริการ การระงับการให้บริการ</strong></p><p>4.1 ในกรณีที่ผู้ใช้บริการประสงค์จะยกเลิกการใช้บริการ ผู้ใช้บริการต้องแจ้งความประสงค์ด้วยตนเองทางโทรศัพท์มายังหมายเลข 3333 หรือ 02-647-3333 หรือ สามารถแจ้งความประสงค์ได้ที่สาขาของบริษัท โดยต้องแสดงบัตรประชาชน หรือเอกสารราชการอื่นใดที่สามารถใช้ยืนยันตัวตนของผู้ใช้บริการ และหากยังคงมีเงินคงเหลือในบัญชีทรูมันนี่ และผู้ใช้บริการไม่ได้ปฏิบัติผิดเงื่อนไขการใช้บริการฉบับนี้ บริษัทจะดําเนินการคืนให้ผู้ใช้บริการภายหลังจากหักค่าธรรมเนียมใดๆ (ถ้ามี) ภายในระยะเวลาที่บริษัทกําหนด แต่ไม่เกิน 15 วันทำการ โดยผู้ใช้บริการตกลงไม่คิดดอกเบี้ยหรือค่าตอบแทนใดๆ กับบริษัท</p><p>4.2 บริษัทสงวนสิทธิ์ยกเลิกการให้บริการชั่วคราวหรือถาวร หรือระงับการให้บริการโดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ในกรณีดังต่อไปนี้</p><p>4.2.1 ผู้ใช้บริการใช้เอกสารปลอม หรือแสดงข้อความอันเป็นเท็จในการลงทะเบียนสมัครบัญชีทรูมันนี่ รวมถึงการแจ้งข้อมูล หรือแสดงเอกสารหลักฐานอันเป็นเท็จ หรือแสดงเอกสารหลักฐานไม่ครบถ้วนตามที่บริษัทร้องขอ จนกว่าบริษัทจะได้รับข้อมูลที่ถูกต้อง ครบถ้วน</p><p>4.2.2 ผู้ใช้บริการถึงแก่ความตาย หรือสิ้นสภาพนิติบุคคล</p><p>4.2.3 ผู้ใช้บริการเป็นบุคคลที่ราชการหรือหน่วยงานของรัฐมีคำสั่งให้ยึดหรืออายัด ทรัพย์สิน หรือเป็นบุคคลที่ถูกกำหนด หรือถูกกล่าวหา หรือถูกสงสัยว่าเป็นผู้กระทำความผิดตามกฎหมาย</p><p>4.2.4 บริษัทมีเหตุสงสัยว่าผู้ใช้บริการกระทำความผิด หรือพยายามกระทำความผิดตามที่กฎหมายกำหนด หรือกระทำการใดๆ ที่อาจก่อให้เกิดความเสียหายกับบริษัท หรือบุคคลอื่นใด</p><p><strong>5. คํารับรองของผู้ใช้บริการ</strong></p><p>5.1 ผู้ใช้บริการรับรองว่ามีอายุครบตามกฎหมาย หรือผู้ใช้บริการได้รับความยินยอมตามกฎหมาย ในการผูกพันตามเงื่อนไขการให้บริการฉบับนี้ และผู้ใช้บริการเข้าใจดีว่าผู้ใช้บริการต้องรับผิดชอบต่อผลทางการเงิน หรือผลอื่นใดที่เกิดขึ้น หรืออาจเกิดขึ้นอันเนื่องมาจากการใช้บริการที่ผู้ใช้บริการ เป็นผู้กระทําหรืออนุญาตให้บุคคลที่สามใช้ข้อมูลการลง ทะเบียน รหัสผ่าน หรือข้อมูลอื่นใดของผู้ใช้บริการ</p><p>5.2 ผู้ใช้บริการรับรองว่าจะไม่ใช้บริการนี้ในการทําธุรกรรมทางการเงินที่มีวัตถุประสงค์อันมิชอบด้วยกฎหมาย ไม่ว่าจะเป็นการพนัน การค้าบริการทางเพศ การฟอกเงิน หรือนำบัญชี (TrueMoney Wallet) ไปแสวงหาประโยชน์ซึ่งมีลักษณะเป็นตัวแทนรับชำระเงิน หรือ นำไปประกอบธุรกิจในรูปแบบต่างๆ รวมถึงการกระทําซึ่งมีลักษณะฝ่าฝืนต่อความสงบเรียบร้อยหรือศีลธรรมอันดีของประชาชน หรือละเมิดสิทธิทางทรัพย์สินทางปัญญาของผู้อื่น หรือเป็นการกระทําผิดกฎหมายอื่นใด ดังนั้น หากเกิดความเสียหายใดๆ ขึ้นแก่บริษัท หรือบริษัทถูกเรียกร้องให้ต้องรับผิดใดๆ จากการที่ผู้ใช้บริการทําธุรกรรมทางการเงินผ่านบริการของบริษัทเพื่อจุดประสงค์ดังกล่าวข้างต้น บริษัทมีสิทธิระงับหรือยกเลิกการให้บริการได้ทันที และผู้ใช้บริการจะต้องรับผิดชอบชดใช้ค่าเสียหายให้แก่บริษัททุกประการ บริษัทขอสงวนสิทธิในการระงับ และ/หรือยกเลิกการใช้บริการของผู้ใช้บริการ ทั้งนี้ บริษัทไม่มีส่วนเกี่ยวข้องหรือรับผิดชอบในความเสียหายทั้งหมด ที่จะเกิดขึ้น</p><p>5.3 ผู้ใช้บริการรับรองว่าข้อมูลที่ให้แก่บริษัทตามข้อ 2.1 ของเงื่อนไขการให้บริการฉบับนี้ และข้อมูลอื่นใดที่ผู้ใช้บริการส่งมอบให้แก่บริษัท เป็นข้อมูลที่ถูกต้องทุกประการ หากบริษัทตรวจพบว่าผู้ใช้บริการปลอมแปลงข้อมูลเอกสาร และ/หรือสวมรอยเป็นบุคคลใดไม่ว่าบุคคลนั้น จะยินยอมหรือไม่ในการสมัครใช้บริการนี้ บริษัทสงวนสิทธิ์ระงับหรือยกเลิกการให้บริการได้ทันทีและผู้ใช้บริการจะต้องรับผิดชอบชดใช้ค่าเสียหายให้แก่บริษัททุกประการ ทั้งนี้ไม่ว่าผู้ใช้บริการจะมีเจตนาทุจริตหรือไม่ก็ตาม</p><p>5.4 ผู้ใช้บริการรับรองว่าตกลงผูกพันปฏิบัติตามและให้ความร่วมมือในการปฏิบัติตามข้อกําหนด ประกาศกฎระเบียบของธนาคารแห่งประเทศไทย สํานักงานป้องกันและปราบปรามการฟอกเงิน หรือบทบัญญัติของกฎหมายใดๆ ที่เกี่ยวข้องกับการดําเนินการตามเงื่อนไขการให้บริการฉบับนี้ ทั้งที่มีอยู่ในปัจจุบันและ/หรือที่จะมีขึ้นต่อไปในภายหน้าโดยเคร่งครัด</p><p><strong>6. การเปิดเผยข้อมูล</strong></p><p>6.1 ผู้ใช้บริการยินยอมให้บริษัทเปิดเผยข้อมูลส่วนบุคคล หรือข้อมูลใดๆ ของผู้ใช้บริการที่มีอยู่กับบริษัทให้แก่บุคคลอื่นใดเพื่อประโยชน์ในการให้บริการของบริษัท รวมถึงยินยอมให้บริษัทเปิดเผยข้อมูลให้แก่บริษัท แอสเซนด์ กรุ๊ป จำกัด, บริษัท ทรู คอร์ปอเรชั่น จำกัด (มหาชน), บริษัท เครือเจริญโภคภัณฑ์ จำกัด และ/หรือบริษัทในเครือของบริษัทดังกล่าวทั้งหมดข้างต้น เพื่อเป็นการอำนวยความสะดวกในการดำเนินการต่าง ๆ ที่เกี่ยวข้อง รวมถึงยินยอมให้บริษัทดังกล่าวติดต่อผู้ใช้บริการได้ เพื่อนำเสนอข่าวสาร / กิจกรรมทางการตลาด / รายการส่งเสริมการขาย / แคมเปญ หรือนำเสนอผลิตภัณฑ์ต่างๆ ที่เป็นประโยชน์ให้แก่ผู้ใช้บริการได้</p><p>6.2 ผู้ใช้บริการตกลงยินยอมให้บริษัท แอสเซนด์ กรุ๊ป จำกัด, บริษัท ทรู คอร์ปอเรชั่น จำกัด (มหาชน), บริษัท เครือเจริญโภคภัณฑ์ จำกัด และ/หรือบริษัทในเครือของบริษัททั้งหมดดังกล่าว เปิดเผยข้อมูลของผู้ใช้บริการซึ่งให้ไว้แก่บริษัทดังกล่าวกับบริษัท และ/หรือบริษัทในเครือของบริษัท เพื่อตรวจสอบและยืนยันข้อมูลส่วนบุคคลของผู้ใช้บริการ, เพื่อรับข้อมูลหรือข่าวสาร, เพื่อวัตถุประสงค์ทางการตลาดและการส่งเสริมการขาย, เพื่อการเสนอสิทธิประโยชน์และ/หรือเสนอขายสินค้าหรือบริการใดๆ, เพื่อประโยชน์ในการให้บริการหรือการทำธุรกรรมทางการเงิน, เพื่อการสถิติ วิเคราะห์ ศึกษาวิจัย ประเมินผลข้อมูล หรือเพื่อวัตถุประสงค์อื่นใดที่ไม่ต้องห้ามตามกฎหมาย</p></div><div class=faded-scroller></div><div class=modal-footer ng-click=closeRegisterConditionModal()><div class=text-center><a data-dismiss=modal aria-label=Close>ปิด</a></div></div>");
$templateCache.put("app/components/modal/register-privacy.html","<div class=\"modal-header disalbe-user-select\"><button ng-click=closeRegisterPrivacyModal() type=button class=close data-dismiss=modal aria-label=Close><i class=\"fa fa-times\" aria-hidden=true></i></button><h4 class=modal-title id=myModalLabel>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</h4></div><div class=\"modal-body disalbe-user-select\"><p>บริษัท ทรู มันนี่ จํากัด (“บริษัท”) ตระหนักถึงความสําคัญเรื่อง การคุ้มครองข้อมูลส่วนบุคคลของท่าน บริษัทจึงได้เลือกใช้เทคโนโลยีที่ทันสมัยและปลอดภัยตามหลักมาตรฐานสากล รวมทั้งทดสอบและปรับปรุงประสิทธิภาพของระบบอย่างสม่ำเสมอเพื่อเพิ่มความมั่นใจให้ท่านสามารถใช้บริการแอพพลิเคชั่น TrueMoney Wallet ได้อย่างมั่นใจ</p><p><strong>การรักษาข้อมูลและการใช้ข้อมูล</strong></p><p>บริษัทจะจัดเก็บข้อมูลส่วนบุคคลของท่านตลอดระยะเวลาที่ท่านใช้บริการแอพพลิเคชั่น TrueMoney Wallet หรือตามระยะเวลาที่บริษัทกําหนด โดยบริษัทอาจใช้ข้อมูลส่วนบุคคลของท่านเพื่อยืนยันตัวตนในการทําธุรกรรมทางการเงิน, เพื่ออนุญาตให้ท่านเข้าถึงข้อมูลที่มีลักษณะพิเศษ, เพื่อใช้การ ทําธุรกรรมทางการเงินที่เกี่ยวข้องกับบุคคลภายนอก หรือเพื่อให้บริษัทสามารถดําเนินการอื่นใดที่เกี่ยวข้องกับการใช้ บริการแอพพลิเคชั่น TrueMoney Wallet ของท่าน รวมถึงใช้ ในการติดต่อกับท่านในกรณีที่จําเป็น และในบางกรณีที่บริษัทไม่สามารถทําการตรวจสอบตัวตนของท่านจากข้อมูลที่ท่านให้ไว้กับบริษัท บริษัทอาจร้องขอเอกสารเพิ่มเติม หรือสอบถามข้อมูลเพิ่มเติมจากท่านผ่านทางเจ้าหน้าที่ของบริษัท</p><p>ในกรณีที่ข้อมูลส่วนบุคคล หรือข้อมูลที่เกี่ยวข้องของท่านถูกจารกรรมทางคอมพิวเตอร์ (Hack) สูญหาย หรือเสียหายซึ่งมิใช่ความผิดของบริษัท บริษัทขอสงวนสิทธิ์ที่จะปฏิเสธความรับผิดใดๆ อันเป็นผลมาจากการดังกล่าว</p><p>อนึ่ง การใช้บริการแอพพลิเคชั่น TrueMoney Wallet ของท่านถือเป็นการยอมรับนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ โดยบริษัทอาจแก้ไขหรือเพิ่มเติมนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ได้ไม่ว่าในเวลาใด และการที่ท่านใช้งานแอพพลิเคชั่นอย่างต่อเนื่องภายหลังจากที่มีการประกาศแก้ไขหรือเพิ่มเติมดังกล่าว ย่อมถือเป็นการยอมรับการแก้ไขแต่ละครั้ง ทั้งนี้ หากท่านมีข้อสงสัยเพิ่มเติมท่านสามารถติดต่อกับเจ้าหน้าที่ของบริษัทได้ทัน</p><p><strong>การเปิดเผยข้อมูลแก่บุคคลที่สาม</strong></p><p>นอกเหนือจากความยินยอมให้เปิดเผยข้อมูลของผู้ใช้บริการที่กำหนดไว้โดยเฉพาะในเงื่อนไขการให้บริการแอพพลิเคชั่น TrueMoney Wallet บริษัทไม่มีนโยบายในการเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลที่สามโดยมิได้รับความยินยอมโดยชัดแจ้งจากท่าน เว้นแต่เป็นการให้ข้อมูลตามที่กฎหมายกําหนด หรือเมื่อมีหมายเรียกของศาลหรือมีคําสั่งที่ถูกต้องตามกฎหมายของหน่วยงานของรัฐที่เกี่ยวข้อง</p></div><div class=faded-scroller></div><div class=modal-footer ng-click=closeRegisterPrivacyModal()><div class=text-center><a data-dismiss=modal aria-label=Close>ปิด</a></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/components/directives/carousel/carousel.html","<!-- Indicators --><ol class=carousel-indicators><li data-target=#myCarousel data-slide-to={{$index}} ng-class=\"{\'active\': $first}\" ng-repeat=\"item in items.image\"></li></ol><!-- Submit Button --><div class=wrap-btnr><a href={{items.link}}><img ng-src={{items.buttonImage}}></a></div><!-- Wrapper for slides --><div class=carousel-inner ng-style=\"{\'background-image\':\'url({{items.bgImage}})\'}\"><carousel-item ng-class=\"{\'active\': $first}\" class=item ng-style=\"{\'background-image\':\'url({{item.image_upper}})\'}\" ng-repeat=\"item in items.image\"><div class=imageCenter ng-style=\"{\'background-image\':\'url({{item.image_lower}})\'}\"></div></carousel-item></div>");
$templateCache.put("app/components/directives/dob/dob.html","<div class=form-group ng-class=\"{ \'has-error\': form.birthdate.$error.max || form.birthdate.$error.min || (form.birthdate.$error.required && form.birthdate.$touched) , \'valid\': !d }\"><label class=control-label>วันเกิด</label><input autocomplete=off type=date class=\"form-control font-wallet-num\" id=birthdate name=birthdate ng-model=d ng-change=change() min={{year100}} max={{today}} placeholder=\"วัน / เดือน / ปี\" required> <span ng-show=\"form.birthdate.$error.required && form.birthdate.$touched\" class=help-block>กรุณาเลือกวันเดือนปีเกิด</span> <span ng-show=\"form.birthdate.$error.max || form.birthdate.$error.min\" class=help-block translate>DOB.ERROR</span></div>");
$templateCache.put("app/components/directives/email/email.html","<div class=form-group ng-class=\"{ \'has-error\': invalid || (form.email.$invalid && form.email.$touched) , \'valid\': !email }\"><label class=control-label>อีเมล</label><input autocomplete=off type=email class=form-control ng-model=email name=email placeholder=email@example.com required> <span ng-show=\"!invalid && email.length != 0\" class=help-block translate>EMAIL.INVALID_FORMAT</span> <span ng-show=\"!invalid && email.length == 0\" class=help-block translate>EMAIL.INVALID</span> <span ng-show=invalid class=help-block translate>EMAIL.USED</span></div>");
$templateCache.put("app/components/directives/fullname/fullname.html","<div class=form-group ng-class=\"{ \'has-error\': form.firstname.$error.required && form.firstname.$touched , \'valid\' : !firstname }\"><label class=control-label>ชื่อ นามสกุล ภาษาไทย<div class=label-desc>(ตามบัตรประจำตัวประชาชน)</div></label><input type=hidden class=form-control name=title ng-model=title value=คุณ ng-init=\"title=\'คุณ\'\"> <input autocomplete=off autocomplete=off autocorrect=off autocapitalize=off spellcheck=false type=text class=form-control id=firstname ng-model=firstname name=firstname maxlength=40 placeholder=\"ชื่อ (ภาษาไทย)\" required> <span class=help-block id=3 ng-class=\"form.firstname.$error.required && form.firstname.$touched ? \'has-error\':\'\'\" translate>FULLNAME.INVALID_FIRSTNAME</span></div><div class=form-group ng-class=\"{ \'has-error\': form.lastname.$invalid && form.lastname.$touched , \'valid\': !lastname }\"><input autocomplete=off autocomplete=off autocorrect=off autocapitalize=off spellcheck=false type=text class=form-control name=lastname ng-model=lastname id=lastname maxlength=40 placeholder=\"นามสกุล (ภาษาไทย)\" required> <span class=help-block translate>FULLNAME.INVALID_LASTNAME</span></div>");
$templateCache.put("app/components/directives/laser/laser.html","<div class=form-group ng-class=\"{ \'has-error\': showLaserError , \'valid\': !laser }\"><label class=control-label>เลขหลังบัตรประจำตัวประชาชน <a href=javascript:void(0) ng-click=showBackId()><i class=icon-info></i></a><div class=label-desc>ขึ้นต้นด้วยตัวอักษร 2 ตัว ตามด้วยเลข 10 หลัก</div></label><input autocomplete=off autocorrect=off autocapitalize=off spellcheck=false ng-trim=false type=text id=laser name=laser class=\"form-control font-wallet-num\" maxlength=14 ng-model=laser placeholder=AA1-2345678-90 ng-blur=\"verifyLaser(\'blur\')\" style=\"text-transform: uppercase\" required> <span class=block-backcard><a href=javascript:void(0) ng-click=showBackId()><img src=../assets/images/idcard-back-mini.png></a></span><span class=help-block ng-if=laser translate>LASER.INVALID_FORMAT</span> <span class=help-block ng-if=!laser translate>LASER.INVALID_LEN</span></div>");
$templateCache.put("app/components/directives/thaiId/thaiId.html","<div class=form-group ng-class=\"{ \'has-error\': showThaiIdError , \'valid\': !thaiid }\"><label class=control-label ng-show=label>{{label}}</label><input autocomplete=off ng-trim=false type=tel class=\"form-control font-wallet-num\" id=thaiid maxlength=17 name=thai-id ng-model=thaiid placeholder=\"กรอกเลขบัตรประชาชน 13 หลัก\" ng-blur=\"verifyThaiId(\'blur\')\" required> <span class=help-block ng-show=!thaiid.length translate>THAI_ID.INVALID_LEN</span> <span class=help-block ng-show=thaiid.length translate>THAI_ID.INVALID_CHECK_SUM</span></div>");}]);